<template>
  <div class="animated fadeIn page-shell">
    <HeaderPadrao class="mb-2" icon="fa fa-shopping-cart" titulo="RETIRADA DO SERVIÇO">
      <template #subtitulo>
        <i class="fa fa-tag mr-1 text-info"></i>
        Pedido: <strong class="text-white">{{ venda.SEQUENCIA > 0 ? venda.SEQUENCIA : 'Novo' }}</strong>
        <span class="mx-2">•</span>
        <i class="fa fa-user mr-1 text-info"></i>
        Cliente: <strong class="text-white">{{ cliente.CODIGO }} - {{ cliente.NOME }}</strong>
      </template>

      <template #acoes>
        <b-button v-if="habilitaBotaoFinalizar" variant="link" class="btn-glass btn-glass-success" @click="liberarOrdem()">
          <i class="fa fa-check mr-1"></i> LIBERAR PRA ORDEM <small>F11</small>
        </b-button>

        <b-button v-if="habilitaBotaoLiberarTerminal" variant="link" class="btn-glass btn-glass-info" @click="liberarProTerminal()">
          <i class="fa fa-truck mr-1"></i> LIBERAR TERMINAL <small>F11</small>
        </b-button>

        <b-button v-if="habilitaBotaoGravar" variant="link" class="btn-glass btn-glass-primary" @click="gravarPedidoEVoltar()">
          <i class="fa fa-save mr-1"></i> GRAVAR <small>F10</small>
        </b-button>

        <b-button v-if="habilitaBotaoExcluir" variant="link" class="btn-glass btn-glass-danger" @click="abrirModalCancelamento()">
          <i class="fa fa-close mr-1"></i> CANCELAR
        </b-button>

        <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm" @click.stop.prevent="voltar()">
          <i class="fa fa-arrow-left mr-1"></i> Voltar
        </b-button>
      </template>
    </HeaderPadrao>

    <div class="page-main px-3">
      <div style="max-height: 80vh; overflow-y: auto; overflow-x: hidden;" class="pr-2">
        <!-- Main Summary Bar 
        <b-row class="mb-4 mt-2">
          <b-col md="2">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-info" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">ICMS Total</small>
              <h4 class="mb-0 font-weight-bold text-dark">{{Number(venda.VL_TOTAL_ICMS || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h4>
            </div>
          </b-col>
          <b-col md="2">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-primary" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">PIS / COFINS</small>
              <h5 class="mb-0 font-weight-bold text-dark">{{(Number(venda.VL_TOTAL_PIS || 0) + Number(venda.VL_TOTAL_COFINS || 0)).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h5>
            </div>
          </b-col>
          <b-col md="2">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-warning" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Volumes / Itens</small>
              <h4 class="mb-0 font-weight-bold text-dark">{{totalPecas || 0}}</h4>
            </div>
          </b-col>
          <b-col md="6">
            <div class="stat-item bg-gradient-primary p-3 rounded shadow text-center transition-hover h-100 d-flex flex-column justify-content-center border-0">
              <small class="modal-label-premium d-block text-white opacity-75">VALOR TOTAL DO PEDIDO</small>
              <h2 class="mb-0 font-weight-bold text-white">{{Number(totalVenda || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h2>
            </div>
          </b-col>
        </b-row>
      -->

        <b-row class="mt-1">
          <b-col sm="12">
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-user-circle mr-2'></i>Identificação
                </h5>
              </div> 
              <b-card-body class="pt-0">
                <b-row>
                  <!--/.col-->
                  <b-col sm="3">
                    <b-form-group label="Pedido ID" label-class="modal-label-premium">
                      <b-form-input 
                        type="text" 
                        id="ID" 
                        :disabled="true" 
                        class="rounded-pill bg-light border-0 shadow-xs"
                        placeholder="Código Automático" 
                        v-model="venda.SEQUENCIA">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <!--/.col-->
                  <b-col sm="3">
                    <b-form-group label="Situação" label-class="modal-label-premium">
                      <b-form-input type="text" id="situacao" :disabled="true" class="rounded-pill bg-light border-0 shadow-xs" :value="traduzirSituacao(venda.SITUACAO)"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <!--/.col-->
                  <b-col sm="3">
                    <b-form-group label="Data do Pedido" label-class="modal-label-premium">
                      <b-form-input  type="date" 
                                      id="edDT_PEDIDO" 
                                      v-model="venda.DT_PEDIDO"
                                      :disabled="controles.fechada"
                                      class="rounded-pill shadow-xs"
                                      :class="{'is-invalid': !venda.DT_PEDIDO }"  
                                      placeholder="Informe Data do Pedido" > 
                        </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group label="Tipo de Contato" label-class="modal-label-premium">
                      <b-form-select :plain="true" 
                                    v-model="venda.PAG2"
                                    class="rounded-pill shadow-xs"
                                    :disabled="controles.fechada"
                                    :options="tipoContatoOptions">
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>  
                <b-row>  
                  <b-col sm="4">
                    <b-form-group label="Ordem Abate" label-class="modal-label-premium">
                      <b-input-group>
                        <b-form-input 
                          id="edABATE_ID" 
                          class="rounded-pill-left shadow-xs bg-light"
                          :disabled="true"
                          v-model="venda.ABATE_ID"
                          placeholder="Selecione o lote..."/>
                        <b-input-group-append>
                          <b-button 
                            :disabled="controles.fechada || tabelaItens.items.length > 0"
                            variant="soft-primary"
                            class="rounded-pill-right shadow-xs px-3"
                            @click="abrirModalAbate()"
                          >
                            <i class="fa fa-list"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>  
                  <b-col sm="8">
                    <b-form-group label="Informações do Abate" label-class="modal-label-premium">
                      <b-form-input 
                        type="text" 
                        id="edTextoAbate" 
                        :disabled="true" 
                        class="rounded-pill bg-light border-0 shadow-xs"
                        v-model="textoAbate">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>  
                  <b-col sm="9">
                    <cliente-pesquisa 
                                    @retornaId="venda.COD_CLI = $event"
                                    :idInicial="venda.COD_CLI"
                                    :classe-required="true"
                                    :desabilitarInput="true"
                                    idModal="modalCliente"
                                    
                                    label="Marchant"
                                    :exibirBloqueado="false"
                                    id="edCOD_CLI"
                                    ref="edCOD_CLI"
                                    place="Informe o Cliente"
                                    :arredondado="true"
                                    labelBotao="">
                    </cliente-pesquisa>
                  </b-col>
                  <b-col sm="2">
                    <b-form-group label="Unidades" label-class="modal-label-premium">
                      <vue-autonumeric  v-model="totalPecas" 
                        :disabled="true"
                        class="form-control rounded-pill bg-light border-0 shadow-xs text-right"
                        :options="{
                              digitGroupSeparator: '.',
                              decimalCharacter: ',',
                              decimalCharacterAlternative: '.',
                              decimalPlaces: '0',
                              roundingMethod: 'U',
                              minimumValue: '0'
                        }">
                      </vue-autonumeric>
                    </b-form-group>
                  </b-col>
                  <b-col sm="1">
                    <b-form-group label="Entrega" label-class="modal-label-premium">
                      <vue-autonumeric  v-model="venda.NENTREGA" 
                        :disabled="controles.fechada"
                        class="form-control rounded-pill shadow-xs text-right"
                        :options="{
                              digitGroupSeparator: '.',
                              decimalCharacter: ',',
                              decimalCharacterAlternative: '.',
                              decimalPlaces: '0',
                              roundingMethod: 'U',
                              minimumValue: '0'
                        }">
                      </vue-autonumeric>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>  
          </b-col>

        </b-row>
            <b-row>
              <b-col sm="12">
                <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
                  <div class="card-header bg-white border-bottom-0 py-3 d-flex justify-content-between align-items-center">
                    <h5 class="mb-0 text-primary font-weight-bold">
                      <i class='fa fa-shopping-basket mr-2'></i>Produtos do Pedido
                    </h5>
                  </div>
                  <b-card-body class="p-0">
                    <b-table 
                            class="mb-0" 
                            stacked="md"
                            responsive
                            hover 
                            small
                            select-mode="single"
                            selectable
                            @row-dblclicked="abrirModalAlterarProduto"
                            :items="tabelaItens.items" 
                            :fields="tabelaItens.fields"
                            head-variant="light">
                      <template #cell(COD_PRO)="row"> 
                          <span class="font-weight-bold text-dark">{{row.item.COD_PRO}}</span>
                      </template>
                      <template #cell(NOME_PRODUTO)="row"> 
                            <span class="text-muted">{{row.item.NOME_PRODUTO}}</span>
                      </template>
                      <template #cell(actions)="linha">
                        <b-button v-if="!controles.fechada" size="sm" variant="soft-danger" pill class="btn-icon" @click.stop.prevent="abrirModalExcluirItem(linha.item)" >
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </template> 
                    </b-table>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
                
      

      <!--/.row-->
    
    </div>
     
    <!--  -----------------------------------------------------------------------------------
                                          MODAL ITENS - PEDIDO WEB
            ----------------------------------------------------------------------------------- -->
    <div>
    </div>
    
    
    <!--  -----------------------------------------------------------------------------------
                                          MODAL ALTERAR ITEM 
    ----------------------------------------------------------------------------------- -->
    <b-modal ref="modal-alterar-item" 
        id="modal-alterar-item" 
        hide-footer
        hide-header
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
        centered
        size="lg"
    >
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
            <div class="header-icon-wrapper-modal mr-3 bg-white-20">
                <i class="fa fa-edit text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Alterar Item do Pedido</h5>
                <small class="text-white opacity-75">AJUSTE DE QUANTIDADES DO PRODUTO SELECIONADO</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-alterar-item')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
      </div>

      <div class="p-4 bg-white">
        <b-overlay :show="cancelamento.parametros.overlayBaixando" rounded="sm">
          <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
              <b-row align-v="center">
                  <b-col md="12">
                      <small class="modal-label-premium">Produto</small>
                      <h5 class="mb-0 font-weight-bold text-primary">{{item.TX_NOME_PRODUTO || item.NOME_PRODUTO}}</h5>
                  </b-col>
              </b-row>
          </div>

          <b-row class="mb-4">
            <b-col md="6">
              <div class="stat-item bg-light p-3 rounded shadow-xs border-0 h-100 text-center">
                <span class="modal-label-premium text-muted d-block">Preço Unitário</span>
                <h4 class="mb-0 font-weight-bold text-dark">{{Number(item.VL_UNT || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h4>
              </div>
            </b-col>
            <b-col md="6">
              <div class="stat-item bg-soft-info p-3 rounded shadow-xs border-0 h-100 text-center">
                <span class="modal-label-premium text-info d-block">Máximo Permitido</span>
                <h4 class="mb-0 font-weight-bold text-info">{{originalPecasPedido}}</h4>
              </div>
            </b-col>
          </b-row>

          <b-row align-v="center" class="justify-content-center">
            <b-col sm="8">
              <label class="modal-label-premium d-block text-center mb-2">Quantidade no Pedido</label>
              <b-input-group class="cec-pill-group shadow-sm">
                <b-input-group-prepend class="cec-pill-append">
                  <b-button   
                        variant="outline-danger"  
                        class="cec-pill-left px-4"
                        @mousedown="handleMouseDownDecrementarItemAlteracao()"
                        @mouseup="handleMouseUpDecrementarItemAlteracao()"
                        @mouseleave="handleMouseLeaveDecrementarItemAlteracao()"
                        @touchstart="handleMouseDownDecrementarItemAlteracao()"
                        @touchend="handleMouseUpDecrementarItemAlteracao()"
                        @touchcancel="handleMouseLeaveDecrementarItemAlteracao()"
                        @contextmenu.prevent>  
                      <i class="fa fa-minus fa-lg"></i>
                  </b-button>
                </b-input-group-prepend>
                
                <vue-autonumeric  v-model="item.PECAS_PEDIDO" 
                                  :disabled="true"
                                  class="form-control text-center font-weight-bold h2 mb-0 py-3"
                                  :options="{
                                        digitGroupSeparator: '.',
                                        decimalCharacter: ',',
                                        decimalCharacterAlternative: '.',
                                        decimalPlaces: '0',
                                        roundingMethod: 'U',
                                        minimumValue: '0',
                                        maximumValue: originalPecasPedido.toString()
                                  }"
                                  :class="{'text-primary': item.PECAS_PEDIDO > 0}">
                </vue-autonumeric>

                <b-input-group-append class="cec-pill-append">
                  <b-button 
                            variant="outline-success" 
                            class="cec-pill-right px-4"
                            @mousedown="handleMouseDownAcrescentarItemAlteracao()"
                            @mouseup="handleMouseUpAcrescentarItemAlteracao()"
                            @mouseleave="handleMouseLeaveAcrescentarItemAlteracao()"
                            @touchstart="handleMouseDownAcrescentarItemAlteracao()"
                            @touchend="handleMouseUpAcrescentarItemAlteracao()"
                            @touchcancel="handleMouseLeaveAcrescentarItemAlteracao()"
                            @contextmenu.prevent> 
                      <i class="fa fa-plus fa-lg"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <small class="text-muted d-block text-center mt-2">
                <i class="fa fa-info-circle mr-1"></i> Use os botões para ajustar a quantidade
              </small>
            </b-col>
          </b-row>
        </b-overlay>
      </div>

      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
         <b-button variant="success" pill class="px-4 font-weight-bold mr-2" @click="editItem()">
            <i class="fa fa-save mr-1"></i> GRAVAR ALTERAÇÃO
        </b-button>
         <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-alterar-item')">
            <i class="fa fa-times mr-1"></i> CANCELAR
        </b-button>
      </div>
    </b-modal>

    
    <!--  -----------------------------------------------------------------------------------
                                          MODAL EXCLUIR ITEM 
            ----------------------------------------------------------------------------------- -->
    <div>
      
        <b-modal ref="modal-excluir-item" 
            id="modal-excluir-item" 
            hide-header
            body-class="p-0"
            size="lg"
            centered
            headerClass= "p-2 border-bottom-0" 
            title="REMOVER ITEM DO PEDIDO" >
          <b-overlay :show="cancelamento.parametros.overlayBaixando" 
                      no-wrap 
                      fixed 
                      z-index="1100" 
                      spinner-variant="primary"
                      spinner-type="border">
            <template #overlay>
              <div class="text-center">
                <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
                <p>Por favor. Aguarde!!!...</p>
              </div>
            </template>
          </b-overlay>
          <b-card no-body class="border-0 shadow-sm rounded-lg overflow-hidden">
              <div class="modal-header-premium bg-gradient-danger text-white p-3">
                  <h5 class="mb-0 font-weight-bold">
                    <i class='fa fa-trash mr-2'></i>Remover o Item do Pedido
                  </h5>
              </div>
              
              <b-card-body class="p-4">
                <b-row class="mb-3">
                  <b-col>
                    <h5 class="text-danger font-weight-bold mb-0">{{itemExcluir.CODIGO_NOME_PRODUTO}}</h5>
                  </b-col>
                </b-row>

                <div class="bg-light p-3 rounded shadow-xs border-0">
                  <b-row class="mb-2" align-v="center">
                    <b-col sm="4">
                      <span class="modal-label-premium text-muted">Quantidade:</span>
                    </b-col>
                    <b-col sm="8" class="text-right">
                      <h5 class="mb-0 font-weight-bold text-dark">{{itemExcluir.QUANT_MASK}}</h5>
                    </b-col>
                  </b-row>  
                  <b-row class="mb-2" align-v="center">
                    <b-col sm="4">
                      <span class="modal-label-premium text-muted">Peças:</span>
                    </b-col>
                    <b-col sm="8" class="text-right">
                      <h5 class="mb-0 font-weight-bold text-success">{{itemExcluir.PECAS_PEDIDO}}</h5>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" align-v="center">
                    <b-col sm="4">
                      <span class="modal-label-premium text-muted">Embarcados:</span>
                    </b-col>
                    <b-col sm="8" class="text-right">
                      <h5 class="mb-0 font-weight-bold text-danger">{{itemExcluir.PECAS}}</h5>
                    </b-col>
                  </b-row>
                  <b-row align-v="center">
                    <b-col sm="4">
                      <span class="modal-label-premium text-muted">Preço:</span>
                    </b-col>
                    <b-col sm="8" class="text-right">
                      <h5 class="mb-0 font-weight-bold text-primary">{{itemExcluir.VL_UNT? itemExcluir.VL_UNT.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : ''}}</h5>
                    </b-col>
                  </b-row>
                </div>
              </b-card-body>
          </b-card>

          <template #modal-footer="{ cancel }">
            <b-button variant="danger" pill class="px-4 shadow-sm font-weight-bold" @click="deleteItem()">
              <i class="fa fa-trash mr-1"></i> REMOVER ITEM
            </b-button>
            <b-button variant="light" pill class="px-4 shadow-sm font-weight-bold" @click="cancel()">
              FECHAR
            </b-button>
          </template>
        </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL REABRIR VENDA 
            ----------------------------------------------------------------------------------- -->
    <div>
      
        <b-modal ref="modal-reabrir" 
            id="modal-reabrir" 
            hide-header
            body-class="p-0"
            size="lg"
            centered
            headerClass= "p-2 border-bottom-0" 
            title="REABRIR PEDIDO" >
          
          <b-card no-body class="border-0 shadow-sm rounded-lg overflow-hidden">
              <div class="modal-header-premium bg-gradient-warning text-white p-3">
                  <h5 class="mb-0 font-weight-bold">
                    <i class='fa fa-unlock mr-2'></i>Reabrir o Pedido
                  </h5>
              </div>
              <b-card-body class="p-4">
                 <b-row class="mb-3">
                  <b-col>
                    <div class="d-flex align-items-center mb-2">
                      <b-badge variant="warning" pill class="px-3 py-2 mr-3 text-white">
                        <h5 class="mb-0 font-weight-bold">PEDIDO: {{venda.N_VENDA}}</h5>
                      </b-badge>
                      <h5 class="mb-0 text-dark font-weight-bold">{{cliente.CODIGO}} - {{cliente.RAZAOSOCIAL}}</h5>
                    </div>
                  </b-col>
                </b-row>
                
                <div class="stat-item bg-light p-3 rounded shadow-xs mb-4 border-left border-warning" style="border-left-width: 4px !important;">
                  <b-row align-v="center">  
                    <b-col cols="12" md="4">
                      <span class="modal-label-premium text-muted d-block">Valor da Venda</span>
                    </b-col>
                    <b-col cols="12" md="8">
                      <h3 class="mb-0 font-weight-bold text-warning">{{totalVenda.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h3>
                    </b-col>
                  </b-row>
                </div>
              </b-card-body>
          </b-card>

          <template #modal-footer="{ cancel }">
            <b-button variant="warning" pill class="px-4 shadow-sm font-weight-bold text-white" @click="reabrir()">
              <i class="fa fa-unlock mr-1"></i> REABRIR
            </b-button>
            <b-button variant="light" pill class="px-4 shadow-sm font-weight-bold" @click="cancel()">
              FECHAR
            </b-button>
          </template>
        </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL CANCELAR
            ----------------------------------------------------------------------------------- -->
    <div>
      
      <b-modal ref="modal-cancelar" 
          id="modal-Cancelar" 
          hide-header
          body-class="p-0"
          size="lg"
          centered
          headerClass= "p-2 border-bottom-0" 
          title="CANCELAR PEDIDO" >
        
        <b-card no-body class="border-0 shadow-sm rounded-lg overflow-hidden">
            <div class="modal-header-premium bg-gradient-danger text-white p-3">
                <h5 class="mb-0 font-weight-bold">
                  <i class='fa fa-times-circle mr-2'></i>Cancelar o Pedido
                </h5>
            </div>
            <b-card-body class="p-4">
               <b-row class="mb-3">
                <b-col>
                  <div class="d-flex align-items-center mb-2">
                    <b-badge variant="danger" pill class="px-3 py-2 mr-3">
                      <h5 class="mb-0 font-weight-bold">PEDIDO: {{venda.N_VENDA}}</h5>
                    </b-badge>
                    <h5 class="mb-0 text-dark font-weight-bold">{{cliente.CODIGO}} - {{cliente.RAZAOSOCIAL}}</h5>
                  </div>
                </b-col>
              </b-row>
              
              <div class="stat-item bg-light p-3 rounded shadow-xs mb-4 border-left border-danger" style="border-left-width: 4px !important;">
                <b-row align-v="center">  
                  <b-col cols="12" md="4">
                    <span class="modal-label-premium text-muted d-block">Ordem de Abate</span>
                  </b-col>
                  <b-col cols="12" md="8">
                    <h3 class="mb-0 font-weight-bold text-danger">{{textoAbate}}</h3>
                  </b-col>
                </b-row>
              </div>
            </b-card-body>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button variant="danger" pill class="px-4 shadow-sm font-weight-bold" @click="cancelar()">
            <i class="fa fa-check mr-1"></i> CONFIRMAR CANCELAMENTO
          </b-button>
          <b-button variant="light" pill class="px-4 shadow-sm font-weight-bold" @click="cancel()">
            FECHAR
          </b-button>
        </template>
      </b-modal>
      </div>
    </div>

    <!--  -----------------------------------------------------------------------------------
                                          MODAL PESQUISA ABATE
            ----------------------------------------------------------------------------------- -->
    <b-modal ref="modal-abate" 
        id="modal-abate" 
        size="xl"
        centered
        hide-footer
        hide-header
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
    >
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
            <div class="header-icon-wrapper-modal mr-3 bg-white-20">
                <i class="fa fa-list-alt text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Localizar Lotes de Abate</h5>
                <small class="text-white opacity-75">LISTA DE LOTES DISPONÍVEIS PARA O PEDIDO</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-abate')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
      </div>

      <div class="p-0 bg-light">
        <b-overlay :show="modalAbate.busy" rounded="sm">
            
            <div class="p-3 bg-white border-bottom">
                 <h6 class="modal-label-premium mb-2"><i class="fa fa-search mr-1"></i> Selecione um Lote</h6>
                 <div class="rounded border shadow-sm overflow-hidden" style="max-height: 300px; overflow-y: auto;">
                    <b-table
                        striped
                        hover
                        sticky-header="300px"
                        :small="true"
                        :items="modalAbate.items"
                        :fields="modalAbate.fields"
                        select-mode="single"
                        selectable
                        @row-selected="selecionarLoteAbate"
                        show-empty
                        empty-text="Nenhum lote de abate encontrado para seleção"
                        class="mb-0 table-finance"
                        head-variant="light" 
                    >
                         <template #cell(ID)="row">
                            <span class="badge badge-pill badge-soft-primary font-weight-bold px-3 py-1">{{row.item.ID}}</span>
                         </template>
                         <template #custom-foot="{ fields }">
                            <b-tr class="bg-light">
                                <b-td v-for="field in fields" :key="field.key" :class="field.class">
                                <span v-if="field.key === 'LOTE'" class="font-weight-bold text-uppercase text-muted text-xs">Total Geral</span>
                                <span v-if="field.key === 'QUANT'" class="font-weight-bold text-primary">{{ totalPesoGeral.toFixed(2) }}</span>
                                </b-td>
                            </b-tr>
                        </template>
                    </b-table>
                 </div>
                 
                 <div v-if="!modalAbate.selecionado" class="mt-2 text-center text-muted">
                    <small><i class="fa fa-info-circle mr-1"></i> Clique em um lote acima para visualizar os detalhes.</small>
                 </div>
            </div>

            <div class="p-3">
                <b-row>
                    <b-col md="6">
                        <b-card no-body class="border-0 shadow-sm h-100">
                            <div class="card-header bg-white border-bottom-0 pt-3 pb-2">
                                <div class="d-flex align-items-center">
                                    <div class="icon-square bg-soft-info mr-2 rounded-circle d-flex align-items-center justify-content-center" style="width:32px; height:32px">
                                        <i class="fa fa-cubes text-info"></i>
                                    </div>
                                    <div>
                                        <h6 class="mb-0 font-weight-bold text-dark">Itens do Lote</h6>
                                        <small class="text-muted">Produtos contidos no lote selecionado</small>
                                    </div>
                                </div>
                            </div>
                            <b-card-body class="p-0">
                                <div style="max-height: 200px; overflow-y: auto;">
                                    <b-table
                                        hover
                                        :small="true"
                                        :items="modalAbate.itemsLote"
                                        :fields="modalAbate.fieldsLote"
                                        show-empty
                                        empty-text="Aguardando seleção..."
                                        class="mb-0 table-finance border-top"
                                    >
                                        <template #custom-foot="{ fields }">
                                            <b-tr class="bg-light">
                                                <b-td v-for="field in fields" :key="field.key" :class="field.class">
                                                <span v-if="field.key === 'NOME_PRODUTO'" class="font-weight-bold text-xs text-uppercase text-muted">Totais do Lote</span>
                                                <span v-if="field.key === 'PECAS'" class="font-weight-bold text-dark">{{ totalBandasLote }}</span>
                                                <span v-if="field.key === 'QUANT'" class="font-weight-bold text-dark">{{ totalPesoLote.toFixed(2) }}</span>
                                                </b-td>
                                            </b-tr>
                                        </template>
                                    </b-table>
                                </div>
                            </b-card-body>
                        </b-card>
                    </b-col>

                    <b-col md="6">
                        <b-card no-body class="border-0 shadow-sm h-100">
                           <div class="card-header bg-white border-bottom-0 pt-3 pb-2">
                                <div class="d-flex align-items-center">
                                    <div class="icon-square bg-soft-warning mr-2 rounded-circle d-flex align-items-center justify-content-center" style="width:32px; height:32px">
                                        <i class="fa fa-clipboard-list text-warning"></i>
                                    </div>
                                    <div>
                                        <h6 class="mb-0 font-weight-bold text-dark">Plano de Expedição</h6>
                                        <small class="text-muted">Saldo a retirar por produto</small>
                                    </div>
                                </div>
                            </div>
                            <b-card-body class="p-0">
                                <div style="max-height: 200px; overflow-y: auto;">
                                    <b-table
                                        hover
                                        :small="true"
                                        :items="modalAbate.itemsPlano"
                                        :fields="modalAbate.fieldsPlano"
                                        show-empty
                                        empty-text="Aguardando seleção..."
                                        class="mb-0 table-finance border-top"
                                    >
                                        <template #custom-foot="{ fields }">
                                            <b-tr class="bg-light">
                                                <b-td v-for="field in fields" :key="field.key" :class="field.class">
                                                <span v-if="field.key === 'PRODUTO_BENEFICIADO'" class="font-weight-bold text-xs text-uppercase text-muted">Total Saldo</span>
                                                <span v-if="field.key === 'PECAS_SALDO'" class="font-weight-bold text-warning">{{ totalSaldoPlano }}</span>
                                                </b-td>
                                            </b-tr>
                                        </template>
                                    </b-table>
                                </div>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
            
        </b-overlay>
      </div>

      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between align-items-center">
         <div class="text-muted small">
            <i class="fa fa-circle text-success mr-1" v-if="modalAbate.selecionado"></i>
            <span v-if="modalAbate.selecionado">Lote selecionado para carregamento</span>
            <span v-else>Selecione um lote na lista acima</span>
         </div>
         <div>
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm mr-2" @click="confirmarLoteAbate()" :disabled="!modalAbate.selecionado">
                <i class="fa fa-check mr-1"></i> CONFIRMAR SELEÇÃO
            </b-button>
            <b-button variant="outline-danger" pill class="px-4 font-weight-bold border-0" @click="$bvModal.hide('modal-abate')">
                CANCELAR
            </b-button>
         </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import FuncionarioPesquisa from '../../pesquisa/FuncionarioPesquisa.vue'
import ProdutoPesquisa from '../../pesquisa/ProdutoPesquisa.vue'
import VueAutonumeric from 'vue-autonumeric'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import moment from 'moment'
import Tools from '@/tools/tools.js'

export default {
  components: {
    ClientePesquisa,
    FuncionarioPesquisa,
    ProdutoPesquisa,
    VueAutonumeric,
    HeaderPadrao
  },
  data () {
    return {
      timerBotao: null,
      intervaloBotao: null,
      isProcessoLongo: false,
      testando: true,
      tabIndex: 0,
      precoTabelado: false,
      vendaIdEditar: null,
      vlTotalAntes: 0.00,
      
      tipoMovimentacoes : {
        selected: null,
        options: null
      },
      controles: {
        atualizandoDias: false,
        atualizandoData: false,
        vendaAlteracao: false,
        fechada: false,
        itemAlteracao: false,
        OP_ICMS_SITUACAO_TRIBUTARIA: null,
        expedicaoDireta: false,
        COD_PRO: null,
        campoGerarDocumento: {
          desabilitado: false
        },
        botaoGerarDocumento: {
          value: 'Some value',
          busy: false,
          clicou: false
        }
      },
      cliente: {
        CODIGO: null,
        NOME: null,
        RAZAOSOCIAL: null,
        ID_UF: null,
        FIZ_JUR: null,
        ISENTO_ICMS: null,
        COD_VEND: null,
        NOTAS_EM_ABERT0: 0,
        PRAZO: null,
        TIPO_CLI: null,
        GRUPO_ARECEBER_ID: null
      },
      venda: {
        SEQUENCIA                 : null,
        N_VENDA                   : null,
        DT_SAIDA                  : null,
        COD_CLI                   : null,
        OP_PEDIDO                 : null,
        USUARIO_PEDIDO            : null, 
        TIPO_MOVIMENTACAO_ID      : null,  
        DT_PAG                    : null,
        PAG1                      : null,
        PAG2                      : null,
        PAG3                      : null,
        PAG4                      : null,
        PAG5                      : null,
        TIPO                      : null,
        TIPO_VEN                  : null,
        FORMA                     : null,
        COD_MOTORISTA             : null,
        VL_TOTAL                  : null,
        OBS2                      : null,
        OBS3                      : null,
        LOTE                      : null,
        TIPO_DOCPAG               : null,
        N_DOCPAG                  : null,
        COD_REPRES                : null,
        COD_CONFERENTE            : null,
        ITENS                     : null,
        NENTREGA                  : null,
        PLACA                     : null,
        VL_ENTRADA                : null,
        VL_DESCONTO               : null,
        CFOP                      : null,
        UFENT                     : null,
        TELENT                    : null,
        CONTATOENT                : null,
        BAIRROENT                 : null,
        CIDADEENT                 : null,
        ENDENT                    : null,
        USUARIO                   : null,
        MOT_CANC                  : null,
        NUMNF                     : null,
        SERIENF                   : null,
        UFPLACA                   : null,
        PORCONTA                  : null,
        VOLUMES                   : null,
        PESOLIQUIDO               : null,
        PESOBRUTO                 : null,
        TOTALNF                   : null,
        DT_CANC                   : null,
        DT_ALTERACAO              : null,
        TX_USUARIO_ALTERACAO      : null,
        VL_TOTAL_ANTES_ALTERACAO  : null,
        VL_BASE_CALC_ICMS         : 0.00,
        VL_TOTAL_ICMS             : 0.00,
        VL_BASE_CALC_ST_ICMS      : 0.00,
        VL_TOTAL_ST_ICMS          : 0.00,
        VL_TOTAL_IPI              : 0.00,
        VL_TOTAL_PIS              : 0.00,
        VL_TOTAL_COFINS           : 0.00,
        VL_TOTAL_DESCONTO         : 0.00,
        VL_TOTAL_SEGURO           : 0.00,
        VL_TOTAL_OUTRAS_DESP      : 0.00,
        VL_TOTAL_FRETE            : 0.00,
        NR_PESO_BRUTO             : 0.00,
        VL_TOTAL_PRODUTOS         : 0.00,
        NR_PESO_LIQUIDO           : 0.00,
        VL_TOTAL_NFE              : 0.00,
        OP_FORMA_PAGTO            : null,
        TX_USUARIO_CANCELAMENTO   : null,
        NR_PARCELAS               : null,
        COD_TRANSP                : null,
        ORIGEM                    : null,
        DT_PREVISAO_ENTREGA       : null,
        HORA                      : null,
        DT_PEDIDO                 : Tools.getDataAtual(),
        DT_SISTEMA_CANCELAMENTO   : null,
        DT_CADASTRO_SISTEMA       : null,
        DT_ALTERACAO_SISTEMA      : null,
        OBSERVACOES               : null,
        SITUACAO                  : null,
        DT_RETORNO                : null,
        NOME_RESPONSAVEL_RETORNO  : null,
        DT_LANCAMENTO_RETORNO     : null,
        OBS_RETORNO               : null,
        USUARIO_RETORNO           : null,
        VL_TOTAL_RETORNO_BKP      : 0.00,
        VL_TOTAL_RETORNO          : 0.00,
        DT_LANCAMENTO_WEB         : null,
        OP_LANCAMENTO_WEB         : null,
        USUARIO_LANCAMENTO_WEB    : null,
        OBS_PEDIDO                : null,
        DT_INICIAR_PAGAMENTO      : null,
        ABATE_ID                  : null,

      },
      textoAbate: '',
      tabelaPreco:{
        selected: null,
        options:[]
      },
      itemExcluir: {
        CONTROLE: null,
        COD_PRO: null,
        COD_CENTRO: null,
        CODIGO_NOME_PRODUTO: '',
        QUANT: 0.00,
        PECAS_PEDIDO: 0,
        PECAS: 0,
        TX_UNIDADE_COMERCIAL: '',
        VL_UNT: 0.00,
        VL_DESCONTO: 0.00,
        VL_TOTAL: 0.00
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          processando: false,
          busy: false
        }
      },
      modalReabrir: {
        parametros: {
          overlayBaixando: false,
          processando: false,
          busy: false,
          permissao : false
        }
      },
      
      parametros: {},
      item: {
        CONTROLE                       : null, 
        SEQUENCIA                      : null, 
        COD_PRO                        : null, 
        EAN                            : null, 
        QUANT                          : null, 
        VL_UNT                         : null, 
        VL_CUSTO                       : null, 
        UND_PECAS                      : null, 
        PECAS                          : null, 
        DT_VENDA                       : null, 
        TIPO_CLI                       : null, 
        MARCA                          : null, 
        TIPO_VEN                       : null, 
        ALTERA                         : null, 
        ITEM                           : null, 
        VL_COMISSAO                    : null, 
        COD_CENTRO                     : null, 
        ICMS                           : null, 
        IPI                            : null, 
        ISS                            : null, 
        IRRF                           : null, 
        ICMSSUBSTITUI                  : null, 
        FORMA                          : null, 
        ID_CFOP                        : null, 
        OP_STATUS_PRECO                : null, 
        VL_TOTAL_BRUTO                 : 0.00, 
        VL_TOTAL_DESCONTO              : null, 
        OP_ICMS_SITUACAO_TRIBUTARIA    : null, 
        OP_ICMS_ORIGEM                 : null, 
        OP_ICMS_MODAL_DETERM_BC        : null, 
        VL_ICMS_PERCENT_REDUC_BC       : '', 
        VL_ICMS_BASE_CALC              : '', 
        VL_ICMS_ALIQUOTA               : '', 
        VL_ICMS                        : '', 
        OP_ICMS_MODAL_DETERM_BC_ST     : null, 
        VL_ICMS_MARGEM_VL_ADIC_ST      : '', 
        VL_ICMS_PERCENT_REDUC_BC_ST    : '', 
        VL_ICMS_BASE_CALC_ST           : '', 
        VL_ICMS_ALIQUOTA_ST            : '', 
        VL_ICMS_ST                     : '', 
        OP_IPI_SITUACAO_TRIBUTARIA     : null, 
        OP_IPI_CLASS_ENQ_CIG_BEB       : null, 
        TX_IPI_CODIGO_ENQUAD_LEGAL     : null, 
        TX_IPI_CNPJ_PRODUTOR           : null, 
        TX_IPI_NUM_SELO_CONTROLE       : null, 
        OP_IPI_TIPO_CALCULO            : null, 
        VL_IPI_BASE_CALC               : '', 
        VL_IPI_ALIQUOTA                : '', 
        VL_IPI_QUANT_TOTAL_UND_PADRAO  : '', 
        VL_IPI_UNIDADE                 : '', 
        VL_IPI                         : '', 
        OP_PIS_SITUACAO_TRIBUTARIA     : null, 
        OP_PIS_TIPO_CALCULO            : null, 
        VL_PIS_BASE_CALC               : '', 
        VL_PIS_ALIQUOTA_PERCENT        : '', 
        VL_PIS_ALIQUOTA_REAIS          : '', 
        VL_PIS_QUANT_VENDIDA           : '', 
        VL_PIS                         : '', 
        OP_PISST_TIPO_CALCULO          : null, 
        VL_PISST_BASE_CALC             : '', 
        VL_PISST_ALIQUOTA_PERCENT      : '', 
        VL_PISST_ALIQUOTA_REAIS        : '', 
        VL_PISST_QUANT_VENDIDA         : '', 
        VL_PISST                       : '', 
        OP_COFINS_SITUACAO_TRIBUTARIA  : null, 
        OP_COFINS_TIPO_CALCULO         : null, 
        VL_COFINS_BASE_CALC            : '', 
        VL_COFINS_ALIQUOTA_PERCENT     : '', 
        VL_COFINS_ALIQUOTA_REAIS       : '', 
        VL_COFINS_QUANT_VENDIDA        : '', 
        VL_COFINS                      : '', 
        OP_COFINSST_TIPO_CALCULO       : null, 
        VL_COFINSST_BASE_CALC          : '', 
        VL_COFINSST_ALIQUOTA_PERCENT   : '', 
        VL_COFINSST_ALIQUOTA_REAIS     : '', 
        VL_COFINSST_QUANT_VENDIDA      : '', 
        VL_COFINSST                    : '', 
        TX_OBSERVACOES                 : null, 
        OP_COMPOE_VALOR_NFE            : null, 
        VL_ICMS_BC_ST_RETIDO_ANT       : '', 
        VL_ICMS_ST_RETIDO_ANT          : '', 
        VL_ICMS_PERC_BC_OPER_PROPRIA   : '', 
        ID_UF_ICMS_ST                  : null, 
        OP_MOTIVO_DESONERACAO          : null, 
        VL_ALIQ_APLICAVEL_CALC_CREDITO : '', 
        VL_CREDITO_ICMS_APROVEITADO    : '', 
        VL_DESCONTO_PERC               : '', 
        TX_NCM                         : null, 
        TX_NOME_PRODUTO                : null, 
        TX_UNIDADE_COMERCIAL           : null, 
        OP_OCORRENCIA_PRECO            : null, 
        VL_DESCONTO                    : null, 
        ID_UNIDADE_COMERCIAL           : null, 
        OP_TRIBUTACAO                  : null, 
        CEST                           : null, 
        QUANT_BKP                      : null, 
        QUANT_RETORNO                  : null, 
        PECAS_BKP                      : null, 
        PECAS_RETORNO                  : null, 
        PECAS_PEDIDO                   : null,
        OBS_RETORNO                    : null,
        OP_REPESAR                     : null, 
        VL_ICMS_ALIQUOTA_DESONERA      : null,
        VL_ICMS_DESONERA               : null,
        OP_IND_DEDUZ_DESONERA          : null
      },
      tipoVenda: [
        { value: 'VENDA', text: '1 - Romaneio de Vendas' },
        { value: 'PEDIDO', text: '2 - Pedido de Vendas' },
        { value: 'TROCA', text: '3 - Troca de Mercadoria' },
      ],
      tipoPagamento: [
        { value: 'V', text: 'A VISTA' },
        { value: 'P', text: 'A PRAZO'}
      ],
      tipoContatoOptions: [
        { value: '0', text: 'Telefone' },
        { value: '1', text: 'Visita' },
        { value: '2', text: 'Internet' },
      ],
      parcelasVezes: [],
      dias:[],
      produtos: {
        currentPage: 1,
        perPage: 20,
        totalRows: 1,
        items: [],
        campos: [
          {
            key: "ID_PRODUTO",
            label: ' ',
            thStyle: { width: '15% !important'}  
          },
          {
            key: 'QUANTIDADE', 
            label: ' ',
            thStyle: { width: '45% !important '},
            class: 'm-0 p-0 text-right'
          },
          {
            key: "PRECO",
            label: ' ',
            thStyle: { width: '35% !important'},  
            formatter: (value, key, item) => 
                value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : null
          }
        ]
      },
      tabelaItens: {
        fields: [
          {
            key: "COD_PRO",
            label: 'Produto Id',
            thStyle: { width: '10% !important'}  ,
            class:'text-right', 
          },
          {
            key: "NOME_PRODUTO" ,
            label: 'Descrição' ,
            thStyle: { width: '50% !important'}  ,
            thClass:  'text-left'  
          },
          {
            key: "PECAS_PEDIDO" ,
            label: 'Pedido' ,
            thStyle: { width: '10% !important'}  ,
            thClass:  'text-right'  ,
            class:'text-right', 
          },
          {
            key: "PECAS" ,
            label: 'Embarcado' ,
            thStyle: { width: '10% !important'}  ,
            thClass:  'text-right'  ,
            class:'text-right', 
          },
          {
            key: "actions" ,
            label: 'ACOES' ,
            thStyle: { width: '10% !important'}  
          }
        ],
        items: []
      },
      filter: '',
      filterOn: [],
      ignorados: [],
      produto: {
        id: null,
        quantidade : 0.00,
        pecas : 0,
        valor: 0.00,
        total: 0.00
      },
      modalItem:{
        overlayBaixando: false,
        icms: {
          opTipoSituacaoTributariaSimples: [
            { value : '00', text : 'ICMS 00 -Tributada Integralmente'},
            { value : '10', text : 'ICMS 10 - Tributada com cobrança do ICMS por Substituição Tributária'},
            { value : '20', text : 'ICMS 20 - Com redução na base de cálculo'},
            { value : '30', text : 'ICMS 30 - Isenta ou não tributada com cobrança do ICMS por substituição tributária'},
            { value : '40', text : 'ICMS 40 - Isenta'},
            { value : '41', text : 'ICMS 41 - Não tributada'},
            { value : '50', text : 'ICMS 50 - Suspensão'},
            { value : '51', text : 'ICMS 51 - Diferimento'},
            { value : '60', text : 'ICMS 60 - Cobrado anteriormente por substiruição tributária'},
            { value : '70', text : 'ICMS 70 - Com redução da base de cálculo e cobrança do ICMS por substituição tributária'},
            { value : '90', text : 'ICMS 90 - Outras'},
          ],
          opTipoSituacaoTributariaNormal: [
            { value: '101', text: 'ICMS 101 - Tributada com permissão de crédito'},
            { value: '102', text: 'ICMS 102 - Trib utada sem permissão de crédito'},
            { value: '103', text: 'ICMS 103 - Isenção do ICMS para faixa de receita bruta'},
            { value: '201', text: 'ICMS 201 - Tributada com permissão de crédito e com cobrança do ICMS por ST'},
            { value: '202', text: 'ICMS 202 - Tributada sem permissão de crédito e com cobrança do ICMS por ST'},
            { value: '203', text: 'ICMS 203 - Isenção do ICMS para faixa de receita bruta e com cobrança do ICMS por ST'},
            { value: '300', text: 'ICMS 300 - Imune'},
            { value: '400', text: 'ICMS 400 - Não tributada'},
            { value: '500', text: 'ICMS 500 - ICMS cobrado anteriormente por ST ou por antecipação'},
            { value: '900', text: 'ICMS 900 - Outros'}
          ],
          opOrigemMercadoria: [
            { value: '0', text: 'Nacional'},
            { value: '1', text: 'Extrangeira - Importação Direta'},
            { value: '2', text: 'Extrangeira - Adquirida no Mercado Interno'},
          ],
          opModalidade: [
            { value: '0', text: 'Margem Valor Agregado'},
            { value: '1', text: 'Pauta Valor'},
            { value: '2', text: 'Preço tabelado Max. Valor'},
            { value: '3', text: 'Valor da Operação'},
          ],
          opMotivoDesoneracao: [
            { value: '', text: ''},
            { value: '1', text: 'Taxi'},
            { value: '2', text: 'Deficiente Fisico'},
            { value: '3', text: 'Produto Agropecuário'},
            { value: '4', text: 'Frotista/Locadora'},
            { value: '5', text: 'Diplomata/Consultor'},
            { value: '9', text: 'Outros'},
            { value: '6', text: 'Utilit. e Motoc. da Amazônia Ocidental'},
            { value: '7', text: 'SUFRAMA'},
          ],
          opModalidadeST: [
            { value: '0', text: 'Preço Tabelado ou Máximo Sugerido'},
            { value: '1', text: 'Lista Negativa (Valor)'},
            { value: '2', text: 'Lista Positiva (valor)'},
            { value: '3', text: 'Lista Neutra (valor)'},
            { value: '4', text: 'Margem Valor Agregado (%)'},
            { value: '5', text: 'Pauta (valor)'},
          ],
        },
        pis:{
          opTipoSituacaoTributaria: [
            { value: '01', text : 'PIS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text : 'PIS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text : 'PIS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text : 'PIS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text : 'PIS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text : 'PIS 07 - Operação Isenta da Contribuição'},
            { value: '08', text : 'PIS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text : 'PIS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text : 'PIS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        },
        cofins:{
          opTipoSituacaoTributaria: [
            { value: '01', text: 'COFINS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text: 'COFINS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text: 'COFINS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text: 'COFINS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text: 'COFINS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text: 'COFINS 07 - Operação Isenta da Contribuição'},
            { value: '08', text: 'COFINS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text: 'COFINS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text: 'COFINS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        }
      },   
      modalAbate: {
        items: [],
        fields: [
          { key: 'ID', label: 'ID', sortable: true, thClass: 'text-center', class: 'text-center' },
          { key: 'LOTE', label: 'Lote', sortable: true, thClass: 'text-center', class: 'text-center' },
          { key: 'DT_LOTE', label: 'Data/Hora', formatter: value => moment(value).format('DD/MM/YYYY HH:mm'), thClass: 'text-center', class: 'text-center' },
          { key: 'NOME_MARCHANT', label: 'Marchant' },
          { key: 'NOME_CLIENTE', label: 'Fornecedor' },
          { key: 'NOME_FAZENDA', label: 'Fazenda' },
          { key: 'NOME_CENTRO', label: 'Centro Estoque' },
          { key: 'ANIMAIS', label: 'Animais', class: 'text-right', thClass: 'text-right', formatter: value => Number(value || 0).toFixed(2) },
          { key: 'QUANT', label: 'Peso KG', class: 'text-right', thClass: 'text-right', formatter: value => Number(value || 0).toFixed(2) },
          { key: 'MEDIA', label: 'Média', class: 'text-right', thClass: 'text-right', formatter: value => Number(value || 0).toFixed(2) },
        ],
        itemsLote: [],
        fieldsLote: [
          { key: 'PRODUTO_ID', label: 'Código', thClass: 'text-center', class: 'text-center' },
          { key: 'NOME_PRODUTO', label: 'Animal / Produto' },
          { key: 'PECAS', label: 'Bandas', class: 'text-right', thClass: 'text-right' },
          { key: 'QUANT', label: 'Peso KG', class: 'text-right', thClass: 'text-right', formatter: value => Number(value || 0).toFixed(2) },
        ],
        itemsPlano: [],
        fieldsPlano: [
          { key: 'PRODUTO_DISPONIVEL_ID', label: 'Produto ID', thClass: 'text-center', class: 'text-center' },
          { key: 'PRODUTO_BENEFICIADO', label: 'Descrição do Produto' },
          { key: 'PECAS_SALDO', label: 'Saldo a Retirar', class: 'text-right', thClass: 'text-right' },
        ],
        selecionado: null,
        busy: false
      },
      originalPecasPedido: 0,
      icms: {
        habilitado: {
          comboOP_ICMS_ORIGEM              : true, // Sempre Visivel
          
          //Grupo ICMS Normal
          comboOP_ICMS_MODAL_DETERM_BC     : false,
          edVL_ICMS_PERCENT_REDUC_BC       : false,
          edVL_ICMS_BASE_CALC              : false,
          edVL_ICMS_ALIQUOTA               : false,
          edVL_ICMS_PERC_BC_OPER_PROPRIA   : false,
          edVL_ICMS                        : false,

          comboOP_MOTIVO_DESONERACAO       : false,

          //Grupo ICMS Normal ST
          comboOP_ICMS_MODAL_DETERM_BC_ST  : false,
          edVL_ICMS_PERCENT_REDUC_BC_ST    : false,
          edVL_ICMS_MARGEM_VL_ADIC_ST      : false,
          edVL_ICMS_BASE_CALC_ST           : false,
          edVL_ICMS_ALIQUOTA_ST            : false,
          edVL_ICMS_ST                     : false,
          comboID_UF_ICMS_ST               : false,

          //Grupo ICMS Simples
          edVL_ALIQ_APLICAVEL_CALC_CREDITO : false,
          edVL_CREDITO_ICMS_APROVEITADO    : false,

          //Grupo ICMS Simples ST
          edVL_ICMS_BC_ST_RETIDO_ANT       : false,
          edVL_ICMS_ST_RETIDO_ANT          : false,

          
        }
      },

    }
  },
  
  computed: {
    textoImposto() {
      return this.cliente.ISENTO_ICMS ? (this.cliente.ISENTO_ICMS == 1 ? 'ISENTO' : 'SUJEITO') : 'AUSENTE'
    },
    produtoTotal: {
       get() {
        return 0.00
       },
       set() {

       }
    },
    habilitaBotaoProdutos() {
      return (this.controles.fechada == false)
    },
    habilitaBotaoExcluir() {
      return (this.venda.SEQUENCIA > 0) && 
             (['2','3'].includes(this.venda.SITUACAO))
    },
    habilitaBotaoGravar() {
      return (this.controles.fechada == false) && 
             (['2','3','4','5'].includes(this.venda.SITUACAO))
    },
    habilitaBotaoFinalizar() {
      return (this.controles.fechada == false) && 
             (this.controles.expedicaoDireta == false) &&
             (['2'].includes(this.venda.SITUACAO))
    },
    habilitaBotaoLiberarTerminal() {
      return (this.controles.fechada == false) && 
             (this.controles.expedicaoDireta == true) &&
             (['2'].includes(this.venda.SITUACAO)) 
    },
    

    valN_VENDA(){
      return ((this.venda.N_VENDA ) && (this.venda.N_VENDA > 0)) ? true : false
    },
    valCOD_CLI(){
      return ((this.venda.COD_CLI ) && (this.venda.COD_CLI > 0)) ? true : false
    },
    valCOD_CONFERENTE(){
      return ((this.venda.COD_CONFERENTE ) && (this.venda.COD_CONFERENTE > 0)) ? true : false
    },
    valCOD_MOTORISTA(){
      return ((this.venda.COD_MOTORISTA ) && (this.venda.COD_MOTORISTA > 0)) ? true : false
    },
    valOP_FORMA_PAGTO() {
      return ((this.venda.OP_FORMA_PAGTO ) && (this.venda.OP_FORMA_PAGTO != '')) ? true : false
    },
    valPAG1() {
      return this.venda.PAG1 == null ? false : true
    },
    valOBS3() {
      return ((this.venda.OBS3 ) && (this.venda.OBS3 != '')) ? true : false
    },
    totalVenda() {
      return this.venda.VL_TOTAL_NFE && this.venda.VL_TOTAL_NFE > 0 ? this.venda.VL_TOTAL_NFE : 0.00
    },
    totalPesoGeral() {
      return this.modalAbate.items.reduce((acc, item) => acc + Number(item.QUANT || 0), 0)
    },
    totalBandasLote() {
      return this.modalAbate.itemsLote.reduce((acc, item) => acc + Number(item.PECAS || 0), 0)
    },
    totalPesoLote() {
      return this.modalAbate.itemsLote.reduce((acc, item) => acc + Number(item.QUANT || 0), 0)
    },
    totalSaldoPlano() {
      return this.modalAbate.itemsPlano.reduce((acc, item) => acc + Number(item.PECAS_SALDO || 0), 0)
    },
    totalBruto() {
      return this.item.VL_TOTAL_BRUTO && this.item.VL_TOTAL_BRUTO > 0 ? this.item.VL_TOTAL_BRUTO : 0.00
    },
    
    totalQuant(){
      let soma = 0.00
      if (this.tabelaItens.items){
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            soma += it.QUANT
          })
        } 
        return soma
      } else {
        return 0.00
      }
    },
    totalPecas:{
      get() {
        let soma = 0
        if (this.tabelaItens.items){
          if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
            [...this.tabelaItens.items].forEach(it => {
              soma += it.PECAS_PEDIDO
            })
          } 
          return soma
        } else {
          return 0
        }
      },
      set() {
        // Implementar lógica para definir o valor de totalPecas
      }  
    },
    tamanhocampoPagina () {
      if (this.venda.PAGINA) {
        return this.venda.PAGINA.length > 2 ? null : false
      }
      return false
    }
  },
  methods: {
    voltar() {
        // Se já tem um SEQUENCIA (pedido salvo), define como selecionado para recarregar a lista
        if (this.venda.SEQUENCIA) {
          this.$store.commit("retiradaServico/SET_REGISTRO_SELECIONADO_ID", this.venda.SEQUENCIA)
        }
        this.$router.push({ path: '/expedicao/retiradaServico/listagem'})
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.produtos.totalRows = filteredItems.length
      this.produtos.currentPage = 1
    },

    async abrirModalAlterarProduto(item) {
      if (this.controles.fechada) {
        return
      }
      this.tabIndexItem = 0

      if (item && item.CONTROLE) {
        const nomeProdutoSelecionado = item.COD_PRO + ' - ' + (item.TX_NOME_PRODUTO || item.NOME_PRODUTO)
        try {
          this.$store.commit('controle/setAguardando', true)
          this.controles.itemAlteracao = true
          try {
            const result = await this.$http.get(`/api/protected/retiradaservico/item/getById/${item.CONTROLE}`)
            this.controles.montandoItem = true
            this.limparItem(true, result.data[0])
            if (!this.item.TX_NOME_PRODUTO && !this.item.NOME_PRODUTO && nomeProdutoSelecionado) {
              this.item.TX_NOME_PRODUTO = nomeProdutoSelecionado
              this.item.NOME_PRODUTO = nomeProdutoSelecionado
            }
            this.originalPecasPedido = this.item.PECAS_PEDIDO
            
            if (this.venda.ABATE_ID) {
               try {
                  const resPlano = await this.$http.get(`/api/protected/abate/listarItensDoPlanoExpedicao/${this.venda.ABATE_ID}`)
                  if (resPlano.data && resPlano.data.length > 0) {
                      const itemPlano = resPlano.data.find(p => p.PRODUTO_DISPONIVEL_ID == this.item.COD_PRO)
                      if (itemPlano) {
                          const saldoDisponivel = Number(itemPlano.PECAS_SALDO) || 0
                          const quantidadeAtual = Number(this.item.PECAS_PEDIDO) || 0
                          // O máximo permitido é o que já tenho no pedido + o que ainda tem de saldo disponível
                          this.originalPecasPedido = quantidadeAtual + saldoDisponivel
                      }
                  }
               } catch (errPlano) {
                  console.error('Erro ao buscar detalhes do plano de expedição', errPlano)
               }
            }

            this.$refs['modal-alterar-item'].show()
          } catch(err) {
            this.controles.montandoItem = false
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          }
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
      }
    },
    async abrirModalAbate() {
      if (this.controles.fechada) {
        return
      }
      this.modalAbate.items = []
      this.modalAbate.itemsLote = []
      this.modalAbate.itemsPlano = []
      this.modalAbate.selecionado = null
      this.$refs['modal-abate'].show()
      
      try {
        this.modalAbate.busy = true
        const response = await this.$http.get('/api/protected/abate/listarLotesAbertosServico')
        this.modalAbate.items = response.data
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao buscar lotes de abate: ' + err)
      } finally {
        this.modalAbate.busy = false
      }
    },

    async selecionarLoteAbate(items) {
      if (items && items.length > 0) {
        const item = items[0]
        this.modalAbate.selecionado = item
        
        try {
          this.modalAbate.busy = true
          const [resItens, resPlano] = await Promise.all([
            this.$http.get(`/api/protected/abate/item/listarPorAbateId/${item.ID}`),
            this.$http.get(`/api/protected/abate/listarItensDoPlanoExpedicao/${item.ID}`)
          ])
          this.modalAbate.itemsLote = resItens.data
          this.modalAbate.itemsPlano = resPlano.data
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao buscar detalhes do lote: ' + err)
        } finally {
          this.modalAbate.busy = false
        }
      } else {
        this.modalAbate.selecionado = null
        this.modalAbate.itemsLote = []
        this.modalAbate.itemsPlano = []
      }
    },

    async confirmarLoteAbate() {
      if (this.modalAbate.selecionado) {
        this.venda.ABATE_ID = this.modalAbate.selecionado.ID
        // Define o cliente da retirada como o marchant do abate
        this.venda.COD_CLI = this.modalAbate.selecionado.MARCHANT_ID 
        
        try {
          this.$store.commit('controle/setAguardando', true)
          const response = await this.$http.post('/api/protected/retiradaservico/utilizarDoServico', { venda: this.venda })
          
          if (response.data.venda) {
            this.venda = response.data.venda
            this.ajustarCamposTabelaVendas(this.venda)
            
            // Atualiza a rota para modo de edição se foi criado um novo registro
            if (this.venda.SEQUENCIA && !this.controles.vendaAlteracao) {
              this.controles.vendaAlteracao = true
              this.vendaIdEditar = this.venda.SEQUENCIA
              this.$router.replace(`/expedicao/retiradaServico/edit/${this.venda.SEQUENCIA}`)
            }
          }
          
          if (response.data.itens) {
            this.montarTabelaItens(response.data.itens)
          }

          this.$refs['modal-abate'].hide()
        } catch (err) {
          console.error(err)
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao utilizar itens da retirada de serviço: ' + err)
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
      }
    },

    async atualizarPaginaPesquisa(ctx) {
      try {
        await this.$store.dispatch('retiradaServico/GERAR_LISTA')
        return true
      } catch (error) {
        return false
      }
    },
    async gravarPedidoEVoltar() {
      if (!this.avisosGravar()) {
        return
      }
      
      try{
        this.$store.commit('controle/setAguardando', true)
        try {
          
          if (this.controles.vendaAlteracao == false)
            await this.$http.post(`/api/protected/venda/postOnly`, this.venda)
          else 
            await this.$http.post(`/api/protected/venda/editDesktop`, {venda: this.venda})      

          //Atualizar listagem da pagina de Pesquisa
          await this.atualizarPaginaPesquisa()
          this.$store.commit("retiradaServico/SET_REGISTRO_SELECIONADO_ID", this.venda.SEQUENCIA)
          this.$router.push('/expedicao/retiradaServico/listagem')
        } catch (err) {
          const mensagemErro =
            (err.response && err.response.data && (err.response.data.message || JSON.stringify(err.response.data))) ||
            err.message || 'Erro inesperado'

          Tools.exibirMensagem(this.$store, 'Erro', 'warning', `Aviso: ${mensagemErro}`)
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    async gravarVendaSimples() {
      try {  
        const vendaResult = await this.$http.post(`/api/protected/retiradaservico/postOnly`, this.venda)
        this.venda = vendaResult.data
        this.ajustarCamposTabelaVendas(this.venda)
        return true
      } catch(err) {
          throw new Error(err)
      }
    },
    async alterarVendaSimples() {
      try { 
        const response = await this.$http.post(`/api/protected/retiradaservico/edit`, this.venda)
        this.venda = response.data
        this.ajustarCamposTabelaVendas(this.venda)
        return true
      } catch(err) {
          throw new Error(err)
      }
    },
    variantEstoquePecas (value) {
      let $variant = 'text-red'
      if (value > 0) {
        $variant = 'text-blue'
      } 
      return $variant
    },
    montarTabelaItens(itens) {
      this.tabelaItens.items = []
          
      if ( (itens) && (itens.length) ) {

        const dados = itens
        for (let i = 0; i < dados.length; i++) {
          
          if ((dados[i].VL_UNT) && (dados[i].VL_UNT > 0) ) {
              dados[i].VL_UNT = dados[i].VL_UNT.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2})
          }
          
          this.tabelaItens.items.push(dados[i])
        }  
      }
    },
    async deleteItem(){
      this.$store.commit('controle/setAguardando', true)
      try {
        try {
          await this.$http.post(`/api/protected/retiradaservico/item/delete`, {vendaItemId: this.itemExcluir.CONTROLE, venda: this.venda})
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
          return
        }
        
        this.$refs['modal-excluir-item'].hide()
        
        try {
          const responseItens = await this.$http.get('/api/protected/retiradaservico/item/getListagemByPedido/'+this.venda.SEQUENCIA)
          this.montarTabelaItens(responseItens.data)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
        }
        
        try {
          const vendaResponse = await this.$http.get(`/api/protected/retiradaservico/getById/${this.venda.SEQUENCIA}`)
          this.venda = vendaResponse.data[0]
          this.ajustarCamposTabelaVendas(this.venda)
        } catch (err)  {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
        }
        
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Item removido com sucesso!')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async editItem() {
      if (this.item.PECAS_PEDIDO > this.originalPecasPedido) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Não é permitido aumentar a quantidade de peças. Máximo permitido: ${this.originalPecasPedido}`)
        return
      }

      this.$store.commit('controle/setAguardando', true)
      this.item.SEQUENCIA = this.venda.SEQUENCIA
      // Backend table does not persist NOME_PRODUTO, so drop it before sending the payload
      const itemPayload = { ...this.item }
      delete itemPayload.NOME_PRODUTO
      try {
        

        try {
          await this.$http.post(`/api/protected/retiradaservico/item/edit`, 
          { item : itemPayload,
            venda: this.venda
          })
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err)
          return
        }

        this.$refs['modal-alterar-item'].hide()
        
        try {
          const itensResponse = await this.$http.get('/api/protected/retiradaservico/item/getListagemByPedido/'+this.venda.SEQUENCIA)
          
          this.montarTabelaItens(itensResponse.data)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err)
        }
        try {
          const vendaResult = await this.$http.get(`/api/protected/retiradaservico/getById/${this.venda.SEQUENCIA}`)
          this.venda = vendaResult.data[0]
          this.ajustarCamposTabelaVendas(this.venda)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err)
        }
      } finally {  
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    async traduzirAbate() {
      this.textoAbate = ''
      if (this.venda.ABATE_ID && parseInt(this.venda.ABATE_ID) > 0) {
        try {
          const response = await this.$http.get(`/api/protected/producao/getById/${this.venda.ABATE_ID}`)
          const abate = response.data[0]
          if (abate) {
            const dataAbate = moment(abate.DT_LOTE).format('DD/MM/YYYY')
            this.textoAbate = `ORDEM DE ABATE: ${abate.ID}   DATA DO ABATE: ${dataAbate}`
          }
        } catch (err) {
          console.error('Erro ao traduzir abate:', err)
        }
      }
    },
    handleKeydown(event) {
      const key = event.key.toLowerCase()
      const ctrl = event.ctrlKey
      const alt = event.altKey
      const modalAberto = this.$refs['modal-alterar-item']?.isShow === true

      const mapTeclas = {
        f11: () => this.liberarOrdem(),
        f10: () => this.gravarPedidoEVoltar(),
      }

      // Ctrl + F10 ou Ctrl + F11 só funcionam se o modal estiver fechado
      if ((key === 'f10' || key === 'f11') && ctrl && !modalAberto) {
        event.preventDefault()
        mapTeclas[key]?.()
      }

      // Alt + alguma letra
      else if (alt && !modalAberto) {
        switch (key) {
          case 'v':
            event.preventDefault()
            this.$router.go(-1)
            break
          // adicione mais atalhos ALT aqui
        }
      }
    },
    
    async liberarOrdem(){

      if (!this.avisosGravar()) {
        return
      } 

      const confirmacao = await this.$bvModal.msgBoxConfirm('Deseja realmente liberar este pedido para ordem de Expedição?', {
        title: 'Confirmação',
        size: 'sm',
        buttonSize: 'lg',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })

      if (!confirmacao) {
        return
      }

      if (this.vendaIdEditar != null)  {
        this.venda.DT_ALTERACAO = Tools.getDataAtual()
        this.venda.TX_USUARIO_ALTERACAO = ''
        this.venda.DT_ALTERACAO_SISTEMA = Tools.getDataAtual()
        if (this.venda.FORMA === 'VENDA' ) {
            this.venda.TIPO_VEN = '0'
        }
      }
      
     let itens = ''
      
      if (this.tabelaItens.items){
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            itens += it.NOME_PRODUTO.substring(0,4)
          })
        } 
      }

      this.venda.ITENS = itens.substring(0, 49)
      this.venda.USUARIO_PEDIDO = window.localStorage.getItem('login')
      this.venda.USUARIO_LANCAMENTO_WEB = window.localStorage.getItem('login')
      
      let pacote = {
        venda: this.venda,
        itens: this.tabelaItens.items
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.$http.post(`/api/protected/retiradaservico/liberarOrdem`, pacote) 
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
       

        // Atualiza listagem e redireciona (independente do relatório ter dado certo ou não)
        this.$store.commit("retiradaServico/SET_REGISTRO_SELECIONADO_ID", this.venda.SEQUENCIA)
        await this.atualizarPaginaPesquisa()
        
        
        this.$router.push('/expedicao/retiradaservico/listagem')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    async liberarProTerminal(){

      if (this.venda.OP_FORMA_PAGTO === 'V' ) {
        this.venda.NR_PARCELAS = null
        this.venda.PAG1 = null
        this.venda.DT_INICIAR_PAGAMENTO = null
      }

      if (!this.avisosGravar()) {
        return
      } 

      const confirmacao = await this.$bvModal.msgBoxConfirm('Deseja realmente liberar este pedido para o terminal?', {
        title: 'Confirmação',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'info',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })

      if (!confirmacao) {
        return
      }

      let itens = ''
      
      if (this.tabelaItens.items){
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            itens += it.NOME_PRODUTO.substring(0,4)
          })
        } 
      }

      this.venda.ITENS = itens.substring(0, 49)
      this.venda.USUARIO_PEDIDO = window.localStorage.getItem('login')
      this.venda.USUARIO_LANCAMENTO_WEB = window.localStorage.getItem('login')
      // QUANDO GRAVA O PEDIDO DEVERA FICAR EM AGUARDANDO EXPEDICAO 
      this.venda.SITUACAO = '4' // EM ORDEM DE EXPEDICAO


      this.$store.commit('controle/setAguardando', true)
      try {
        try {
          await this.$http.post(`/api/protected/venda/editDesktop`, {venda: this.venda})

        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        /*
        try {
          let response = await this.$http.get(`/api/protected/relatorios/relvendapedido?id=${this.venda.SEQUENCIA}` , {responseType: 'arraybuffer'})
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `relPedido.pdf`) 
          link.download = 'relPedido.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = `${this.venda.N_VENDA} - Pedido`
            }, 3000);
          }

          this.$router.go(-1)
          
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          this.$router.go(-1)
        }
          */

        await this.atualizarPaginaPesquisa()
        this.$store.commit("retiradaServico/SET_REGISTRO_SELECIONADO_ID", this.venda.SEQUENCIA)
        this.$router.push('/expedicao/retiradaservico/listagem')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    
    async abrirModalExcluirItem(item) { 
      this.$store.commit('controle/setAguardando', true)
      this.itemExcluir.CODIGO_NOME_PRODUTO = item.CODIGO_NOME_PRODUTO
      this.itemExcluir.CONTROLE = item.CONTROLE
      try{
        try {
          const result = await this.$http.get('/api/protected/retiradaservico/item/getById/'+this.itemExcluir.CONTROLE)
          this.itemExcluir.CONTROLE = result.data[0].CONTROLE
          this.itemExcluir.COD_PRO = result.data[0].COD_PRO
          this.itemExcluir.COD_CENTRO = result.data[0].COD_CENTRO
          this.itemExcluir.QUANT = result.data[0].QUANT
          this.itemExcluir.PECAS_PEDIDO = result.data[0].PECAS_PEDIDO
          this.itemExcluir.PECAS = result.data[0].PECAS
          this.itemExcluir.TX_UNIDADE_COMERCIAL = result.data[0].ID_UNIDADE_COMERCIAL
          this.itemExcluir.VL_UNT = result.data[0].VL_UNT
          this.itemExcluir.VL_DESCONTO = result.data[0].VL_DESCONTO
          this.itemExcluir.VL_TOTAL_BRUTO = result.data[0].VL_TOTAL_BRUTO
          
          this.itemExcluir.QUANT_MASK          = result.data[0].QUANT ? result.data[0].QUANT.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
          this.itemExcluir.VL_UNT_MASK         = result.data[0].VL_UNT ? result.data[0].VL_UNT.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          this.itemExcluir.VL_DESCONTO_MASK    = result.data[0].VL_DESCONTO ? result.data[0].VL_DESCONTO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          this.itemExcluir.VL_TOTAL_BRUTO_MASK = result.data[0].VL_TOTAL_BRUTO ? result.data[0].VL_TOTAL_BRUTO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          
          this.$refs['modal-excluir-item'].show()
        } catch(err)  {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async reabrir() {
      let situacao = this.venda.SITUACAO
      try {
        
        this.$store.commit('controle/setAguardando', true)
        try {
          this.venda.SITUACAO = '2' //Em cadastro
          await this.$http.post(`/api/protected/vendapedido/reabrir`, this.venda)
          this.controles.fechada = false
          this.$refs['modal-reabrir'].hide()
        } catch(err)  {
          this.venda.SITUACAO = situacao
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async cancelar() {
      try {
        this.$store.commit('controle/setAguardando', true)
        const body = {
          id: this.venda.SEQUENCIA,
          login: window.localStorage.getItem('login'),
          motivo: null
        }
        
        try {
          await this.$http.post(`/api/protected/retiradaservico/cancelar`, body)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return 
        }
        await this.$store.dispatch('retiradaServico/GERAR_LISTA')
      
        this.controles.fechada = false
        this.$refs['modal-cancelar'].hide()

        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'O Pedido foi cancelado com Sucesso!' )
        this.voltar()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    abrirModalReabrir(){
       this.$refs['modal-reabrir'].show()
    },
    abrirModalCancelamento(){
       this.$refs['modal-cancelar'].show()
    },
    colorirTabSelecionada(idx) {
      if (this.tabIndex === idx) {
        return ['bg-gray-600', 'text-white']
        //return ['bg-gray-600', 'text-light']
      } else {
        if (idx === 3 ) {
          return ['bg-green', 'text-light']
        } else {
          return ['bg-dark', 'text-light']
        }
      }
    },
    avisosGravar(){
      let retorno = true
      if (!this.valCOD_CLI) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe o Marchante` )
      } 
      if ((!this.tabelaItens.items.length) || (this.tabelaItens.items.length <= 0) ) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Adicione Produtos` )
      } 

      return retorno
    },
    onHidden_botaoGerarDocumento() {
      // Return focus to the button
      //console.log(this.$refs)
      //this.$refs.ob_edDocumento.focus()
      this.$refs.edCOD_CLI.$refs.auto.$refs.autocomplete.focus()
    },
    postProduto(){

    },
    post () {
      if ( !this.venda.SEQUENCIA || this.venda.SEQUENCIA === null || this.venda.SEQUENCIA === undefined ) {
        this.novo()
      } else {
        this.editar()
      }
    },
    limparItem(alteracao, item) {
      this.item.CONTROLE                       =    item.CONTROLE                       ? item.CONTROLE                       : null 
      this.item.SEQUENCIA                      =    item.SEQUENCIA                      ? item.SEQUENCIA                      : null 
      this.item.COD_PRO                        =    item.COD_PRO                        ? item.COD_PRO                        : null 
      this.item.EAN                            =    item.EAN                            ? item.EAN                            : null 
      this.item.QUANT                          =    item.QUANT                          ? item.QUANT                          : 0.00 
      this.item.VL_UNT                         =    item.VL_UNT                         ? item.VL_UNT                         : 0.00 
      this.item.VL_CUSTO                       =    item.VL_CUSTO                       ? item.VL_CUSTO                       : 0.00 
      this.item.UND_PECAS                      =    item.UND_PECAS                      ? item.UND_PECAS                      : null 
      this.item.PECAS                          =    item.PECAS                          ? item.PECAS                          : 0 
      this.item.DT_VENDA                       =    item.DT_VENDA                       ? item.DT_VENDA                       : new Date() 
      this.item.TIPO_CLI                       =    item.TIPO_CLI                       ? item.TIPO_CLI                       : null 
      this.item.MARCA                          =    item.MARCA                          ? item.MARCA                          : null 
      this.item.TIPO_VEN                       =    item.TIPO_VEN                       ? item.TIPO_VEN                       : null 
      this.item.ALTERA                         =    item.ALTERA                         ? item.ALTERA                         : null 
      this.item.ITEM                           =    item.ITEM                           ? item.ITEM                           : null 
      this.item.VL_COMISSAO                    =    item.VL_COMISSAO                    ? item.VL_COMISSAO                    : 0.00 
      this.item.COD_CENTRO                     =    item.COD_CENTRO                     ? item.COD_CENTRO                     : null 
      this.item.ICMS                           =    item.ICMS                           ? item.ICMS                           : null 
      this.item.IPI                            =    item.IPI                            ? item.IPI                            : null 
      this.item.ISS                            =    item.ISS                            ? item.ISS                            : null 
      this.item.IRRF                           =    item.IRRF                           ? item.IRRF                           : null 
      this.item.ICMSSUBSTITUI                  =    item.ICMSSUBSTITUI                  ? item.ICMSSUBSTITUI                  : null 
      this.item.FORMA                          =    item.FORMA                          ? item.FORMA                          : null 
      this.item.ID_CFOP                        =    item.ID_CFOP                        ? item.ID_CFOP                        : null 
      this.item.OP_STATUS_PRECO                =    item.OP_STATUS_PRECO                ? item.OP_STATUS_PRECO                : null 
      this.item.VL_TOTAL_BRUTO                 =    item.VL_TOTAL_BRUTO                 ? item.VL_TOTAL_BRUTO                 : 0.00 
      this.item.VL_TOTAL_DESCONTO              =    item.VL_TOTAL_DESCONTO              ? item.VL_TOTAL_DESCONTO              : 0.00 
      this.item.VL_DESCONTO_PERC               =    item.VL_DESCONTO_PERC               ? item.VL_DESCONTO_PERC               : 0.00 
      this.item.TX_NCM                         =    item.TX_NCM                         ? item.TX_NCM                         : null 
      this.item.TX_NOME_PRODUTO                =    item.TX_NOME_PRODUTO                ? item.TX_NOME_PRODUTO                : (item.NOME_PRODUTO ? item.NOME_PRODUTO : null)
      this.item.NOME_PRODUTO                   =    item.NOME_PRODUTO                   ? item.NOME_PRODUTO                   : (item.TX_NOME_PRODUTO ? item.TX_NOME_PRODUTO : null)
      this.item.TX_UNIDADE_COMERCIAL           =    item.TX_UNIDADE_COMERCIAL           ? item.TX_UNIDADE_COMERCIAL           : null 
      this.item.OP_OCORRENCIA_PRECO            =    item.OP_OCORRENCIA_PRECO            ? item.OP_OCORRENCIA_PRECO            : null 
      this.item.VL_DESCONTO                    =    item.VL_DESCONTO                    ? item.VL_DESCONTO                    : 0.00 
      this.item.ID_UNIDADE_COMERCIAL           =    item.ID_UNIDADE_COMERCIAL           ? item.ID_UNIDADE_COMERCIAL           : null 
      this.item.OP_TRIBUTACAO                  =    item.OP_TRIBUTACAO                  ? item.OP_TRIBUTACAO                  : null 
      this.item.CEST                           =    item.CEST                           ? item.CEST                           : null 
      this.item.QUANT_BKP                      =    item.QUANT_BKP                      ? item.QUANT_BKP                      : null 
      this.item.QUANT_RETORNO                  =    item.QUANT_RETORNO                  ? item.QUANT_RETORNO                  : null 
      this.item.PECAS_BKP                      =    item.PECAS_BKP                      ? item.PECAS_BKP                      : null 
      this.item.PECAS_RETORNO                  =    item.PECAS_RETORNO                  ? item.PECAS_RETORNO                  : null 
      this.item.PECAS_PEDIDO                   =    item.PECAS_PEDIDO != null           ? item.PECAS_PEDIDO                   : 0 
      this.item.OBS_RETORNO                    =    item.OBS_RETORNO                    ? item.OBS_RETORNO                    : null 
      this.item.TX_OBSERVACOES                 =    item.TX_OBSERVACOES                 ? item.TX_OBSERVACOES                 : null 
      
      if (alteracao == true) {
        this.item.OP_ICMS_SITUACAO_TRIBUTARIA    =    item.OP_ICMS_SITUACAO_TRIBUTARIA    ? item.OP_ICMS_SITUACAO_TRIBUTARIA    : null 
        this.item.OP_ICMS_ORIGEM                 =    item.OP_ICMS_ORIGEM                 ? item.OP_ICMS_ORIGEM                 : null 
        this.item.OP_ICMS_MODAL_DETERM_BC        =    item.OP_ICMS_MODAL_DETERM_BC        ? item.OP_ICMS_MODAL_DETERM_BC        : null 
        this.item.VL_ICMS_PERCENT_REDUC_BC       =    item.VL_ICMS_PERCENT_REDUC_BC       ? item.VL_ICMS_PERCENT_REDUC_BC       : null 
        this.item.VL_ICMS_BASE_CALC              =    item.VL_ICMS_BASE_CALC              ? item.VL_ICMS_BASE_CALC              : null 
        this.item.VL_ICMS_ALIQUOTA               =    item.VL_ICMS_ALIQUOTA               ? item.VL_ICMS_ALIQUOTA               : null 
        this.item.VL_ICMS                        =    item.VL_ICMS                        ? item.VL_ICMS                        : null 
        this.item.OP_ICMS_MODAL_DETERM_BC_ST     =    item.OP_ICMS_MODAL_DETERM_BC_ST     ? item.OP_ICMS_MODAL_DETERM_BC_ST     : null 
        this.item.VL_ICMS_MARGEM_VL_ADIC_ST      =    item.VL_ICMS_MARGEM_VL_ADIC_ST      ? item.VL_ICMS_MARGEM_VL_ADIC_ST      : null 
        this.item.VL_ICMS_PERCENT_REDUC_BC_ST    =    item.VL_ICMS_PERCENT_REDUC_BC_ST    ? item.VL_ICMS_PERCENT_REDUC_BC_ST    : null 
        this.item.VL_ICMS_BASE_CALC_ST           =    item.VL_ICMS_BASE_CALC_ST           ? item.VL_ICMS_BASE_CALC_ST           : null 
        this.item.VL_ICMS_ALIQUOTA_ST            =    item.VL_ICMS_ALIQUOTA_ST            ? item.VL_ICMS_ALIQUOTA_ST            : null 
        this.item.VL_ICMS_ST                     =    item.VL_ICMS_ST                     ? item.VL_ICMS_ST                     : null 
        this.item.OP_IPI_SITUACAO_TRIBUTARIA     =    item.OP_IPI_SITUACAO_TRIBUTARIA     ? item.OP_IPI_SITUACAO_TRIBUTARIA     : null 
        this.item.OP_IPI_CLASS_ENQ_CIG_BEB       =    item.OP_IPI_CLASS_ENQ_CIG_BEB       ? item.OP_IPI_CLASS_ENQ_CIG_BEB       : null 
        this.item.TX_IPI_CODIGO_ENQUAD_LEGAL     =    item.TX_IPI_CODIGO_ENQUAD_LEGAL     ? item.TX_IPI_CODIGO_ENQUAD_LEGAL     : null 
        this.item.TX_IPI_CNPJ_PRODUTOR           =    item.TX_IPI_CNPJ_PRODUTOR           ? item.TX_IPI_CNPJ_PRODUTOR           : null 
        this.item.TX_IPI_NUM_SELO_CONTROLE       =    item.TX_IPI_NUM_SELO_CONTROLE       ? item.TX_IPI_NUM_SELO_CONTROLE       : null 
        this.item.OP_IPI_TIPO_CALCULO            =    item.OP_IPI_TIPO_CALCULO            ? item.OP_IPI_TIPO_CALCULO            : null 
        this.item.VL_IPI_BASE_CALC               =    item.VL_IPI_BASE_CALC               ? item.VL_IPI_BASE_CALC               : null 
        this.item.VL_IPI_ALIQUOTA                =    item.VL_IPI_ALIQUOTA                ? item.VL_IPI_ALIQUOTA                : null 
        this.item.VL_IPI_QUANT_TOTAL_UND_PADRAO  =    item.VL_IPI_QUANT_TOTAL_UND_PADRAO  ? item.VL_IPI_QUANT_TOTAL_UND_PADRAO  : null 
        this.item.VL_IPI_UNIDADE                 =    item.VL_IPI_UNIDADE                 ? item.VL_IPI_UNIDADE                 : null 
        this.item.VL_IPI                         =    item.VL_IPI                         ? item.VL_IPI                         : null 
        this.item.OP_PIS_SITUACAO_TRIBUTARIA     =    item.OP_PIS_SITUACAO_TRIBUTARIA     ? item.OP_PIS_SITUACAO_TRIBUTARIA     : null 
        this.item.OP_PIS_TIPO_CALCULO            =    item.OP_PIS_TIPO_CALCULO            ? item.OP_PIS_TIPO_CALCULO            : null 
        this.item.VL_PIS_BASE_CALC               =    item.VL_PIS_BASE_CALC               ? item.VL_PIS_BASE_CALC               : null 
        this.item.VL_PIS_ALIQUOTA_PERCENT        =    item.VL_PIS_ALIQUOTA_PERCENT        ? item.VL_PIS_ALIQUOTA_PERCENT        : null 
        this.item.VL_PIS_ALIQUOTA_REAIS          =    item.VL_PIS_ALIQUOTA_REAIS          ? item.VL_PIS_ALIQUOTA_REAIS          : null 
        this.item.VL_PIS_QUANT_VENDIDA           =    item.VL_PIS_QUANT_VENDIDA           ? item.VL_PIS_QUANT_VENDIDA           : null 
        this.item.VL_PIS                         =    item.VL_PIS                         ? item.VL_PIS                         : null 
        this.item.OP_PISST_TIPO_CALCULO          =    item.OP_PISST_TIPO_CALCULO          ? item.OP_PISST_TIPO_CALCULO          : null 
        this.item.VL_PISST_BASE_CALC             =    item.VL_PISST_BASE_CALC             ? item.VL_PISST_BASE_CALC             : null 
        this.item.VL_PISST_ALIQUOTA_PERCENT      =    item.VL_PISST_ALIQUOTA_PERCENT      ? item.VL_PISST_ALIQUOTA_PERCENT      : null 
        this.item.VL_PISST_ALIQUOTA_REAIS        =    item.VL_PISST_ALIQUOTA_REAIS        ? item.VL_PISST_ALIQUOTA_REAIS        : null 
        this.item.VL_PISST_QUANT_VENDIDA         =    item.VL_PISST_QUANT_VENDIDA         ? item.VL_PISST_QUANT_VENDIDA         : null 
        this.item.VL_PISST                       =    item.VL_PISST                       ? item.VL_PISST                       : null 
        this.item.OP_COFINS_SITUACAO_TRIBUTARIA  =    item.OP_COFINS_SITUACAO_TRIBUTARIA  ? item.OP_COFINS_SITUACAO_TRIBUTARIA  : null 
        this.item.OP_COFINS_TIPO_CALCULO         =    item.OP_COFINS_TIPO_CALCULO         ? item.OP_COFINS_TIPO_CALCULO         : null 
        this.item.VL_COFINS_BASE_CALC            =    item.VL_COFINS_BASE_CALC            ? item.VL_COFINS_BASE_CALC            : null 
        this.item.VL_COFINS_ALIQUOTA_PERCENT     =    item.VL_COFINS_ALIQUOTA_PERCENT     ? item.VL_COFINS_ALIQUOTA_PERCENT     : null 
        this.item.VL_COFINS_ALIQUOTA_REAIS       =    item.VL_COFINS_ALIQUOTA_REAIS       ? item.VL_COFINS_ALIQUOTA_REAIS       : null 
        this.item.VL_COFINS_QUANT_VENDIDA        =    item.VL_COFINS_QUANT_VENDIDA        ? item.VL_COFINS_QUANT_VENDIDA        : null 
        this.item.VL_COFINS                      =    item.VL_COFINS                      ? item.VL_COFINS                      : null 
        this.item.OP_COFINSST_TIPO_CALCULO       =    item.OP_COFINSST_TIPO_CALCULO       ? item.OP_COFINSST_TIPO_CALCULO       : null 
        this.item.VL_COFINSST_BASE_CALC          =    item.VL_COFINSST_BASE_CALC          ? item.VL_COFINSST_BASE_CALC          : null 
        this.item.VL_COFINSST_ALIQUOTA_PERCENT   =    item.VL_COFINSST_ALIQUOTA_PERCENT   ? item.VL_COFINSST_ALIQUOTA_PERCENT   : null 
        this.item.VL_COFINSST_ALIQUOTA_REAIS     =    item.VL_COFINSST_ALIQUOTA_REAIS     ? item.VL_COFINSST_ALIQUOTA_REAIS     : null 
        this.item.VL_COFINSST_QUANT_VENDIDA      =    item.VL_COFINSST_QUANT_VENDIDA      ? item.VL_COFINSST_QUANT_VENDIDA      : null 
        this.item.VL_COFINSST                    =    item.VL_COFINSST                    ? item.VL_COFINSST                    : null 
        
        this.item.OP_COMPOE_VALOR_NFE            =    item.OP_COMPOE_VALOR_NFE            ? item.OP_COMPOE_VALOR_NFE            : null 
        this.item.VL_ICMS_BC_ST_RETIDO_ANT       =    item.VL_ICMS_BC_ST_RETIDO_ANT       ? item.VL_ICMS_BC_ST_RETIDO_ANT       : null 
        this.item.VL_ICMS_ST_RETIDO_ANT          =    item.VL_ICMS_ST_RETIDO_ANT          ? item.VL_ICMS_ST_RETIDO_ANT          : null 
        this.item.VL_ICMS_PERC_BC_OPER_PROPRIA   =    item.VL_ICMS_PERC_BC_OPER_PROPRIA   ? item.VL_ICMS_PERC_BC_OPER_PROPRIA   : null 
        this.item.ID_UF_ICMS_ST                  =    item.ID_UF_ICMS_ST                  ? item.ID_UF_ICMS_ST                  : null 
        this.item.VL_CREDITO_ICMS_APROVEITADO    =    item.VL_CREDITO_ICMS_APROVEITADO    ? item.VL_CREDITO_ICMS_APROVEITADO    : null 
        
      
        this.item.OP_MOTIVO_DESONERACAO          =    item.OP_MOTIVO_DESONERACAO          ? item.OP_MOTIVO_DESONERACAO          : null 
        this.item.VL_ALIQ_APLICAVEL_CALC_CREDITO =    item.VL_ALIQ_APLICAVEL_CALC_CREDITO ? item.VL_ALIQ_APLICAVEL_CALC_CREDITO : null 
      }
    },
    async limparVenda () {
      this.venda.SEQUENCIA                 = null
      this.venda.N_VENDA                   = null
      this.venda.DT_SAIDA                  = null,
      this.venda.COD_CLI                   = null
      this.venda.DT_PAG                    = null
      this.venda.PAG1                      = null
      this.venda.PAG2                      = '0'
      this.venda.PAG3                      = null
      this.venda.PAG4                      = null
      this.venda.PAG5                      = null
      this.venda.TIPO                      = null
      this.venda.TIPO_VEN                  = '0'
      this.venda.FORMA                     = 'VENDA'
      this.venda.COD_VENDEDOR              = null
      this.venda.COD_MOTORISTA             = null
      this.venda.VL_TOTAL                  = null
      this.venda.OBS2                      = null
      this.venda.OBS3                      = null
      this.venda.LOTE                      = null
      this.venda.TIPO_DOCPAG               = null
      this.venda.N_DOCPAG                  = null
      this.venda.COD_REPRES                = null
      this.venda.COD_CONFERENTE            = null
      this.venda.TIPO_VENDEDOR             = null
      this.venda.ITENS                     = null
      this.venda.NENTREGA                  = '0'
      this.venda.PLACA                     = null
      this.venda.VL_ENTRADA                = null
      this.venda.VL_DESCONTO               = null
      this.venda.CFOP                      = null
      this.venda.UFENT                     = null
      this.venda.TELENT                    = null
      this.venda.CONTATOENT                = null
      this.venda.BAIRROENT                 = null
      this.venda.CIDADEENT                 = null
      this.venda.ENDENT                    = null
      this.venda.USUARIO                   = null
      this.venda.MOT_CANC                  = null
      this.venda.NUMNF                     = null
      this.venda.SERIENF                   = null
      this.venda.UFPLACA                   = null
      this.venda.PORCONTA                  = null
      this.venda.VOLUMES                   = null
      this.venda.PESOLIQUIDO               = 0.00
      this.venda.PESOBRUTO                 = 0.00
      this.venda.TOTALNF                   = null
      this.venda.DT_CANC                   = null
      this.venda.DT_ALTERACAO              = null
      this.venda.TX_USUARIO_ALTERACAO      = null
      this.venda.VL_TOTAL_ANTES_ALTERACAO  = 0.00
      this.venda.VL_BASE_CALC_ICMS         = 0.00
      this.venda.VL_TOTAL_ICMS             = 0.00
      this.venda.VL_BASE_CALC_ST_ICMS      = 0.00
      this.venda.VL_TOTAL_ST_ICMS          = 0.00
      this.venda.VL_TOTAL_IPI              = 0.00
      this.venda.VL_TOTAL_PIS              = 0.00
      this.venda.VL_TOTAL_COFINS           = 0.00
      this.venda.VL_TOTAL_DESCONTO         = 0.00
      this.venda.VL_TOTAL_SEGURO           = 0.00
      this.venda.VL_TOTAL_OUTRAS_DESP      = 0.00
      this.venda.VL_TOTAL_FRETE            = 0.00
      this.venda.NR_PESO_BRUTO             = 0.00
      this.venda.VL_TOTAL_PRODUTOS         = 0.00
      this.venda.NR_PESO_LIQUIDO           = 0.00
      this.venda.VL_TOTAL_NFE              = 0.00
      this.venda.OP_FORMA_PAGTO            = 'V'
      this.venda.TX_USUARIO_CANCELAMENTO   = null
      this.venda.NR_PARCELAS               = null
      this.venda.COD_TRANSP                = null
      this.venda.ORIGEM                    = null
      this.venda.DT_PREVISAO_ENTREGA       = null
      this.venda.HORA                      = null
      this.venda.DT_PEDIDO                 = Tools.getDataAtual(),
      this.venda.DT_SISTEMA_CANCELAMENTO   = null
      this.venda.DT_CADASTRO_SISTEMA       = null
      this.venda.DT_ALTERACAO_SISTEMA      = null
      this.venda.OBSERVACOES               = null
      this.venda.SITUACAO                  = '2'
      this.venda.DT_RETORNO                = null
      this.venda.NOME_RESPONSAVEL_RETORNO  = null
      this.venda.DT_LANCAMENTO_RETORNO     = null
      this.venda.OBS_RETORNO               = null
      this.venda.USUARIO_RETORNO           = null
      this.venda.VL_TOTAL_RETORNO_BKP      = 0.00
      this.venda.VL_TOTAL_RETORNO          = 0.00
      this.venda.DT_LANCAMENTO_WEB         = null
      this.venda.OP_LANCAMENTO_WEB         = null
      this.venda.USUARIO_LANCAMENTO_WEB    = null
      this.venda.OBS_PEDIDO                = null
      this.venda.DT_INICIAR_PAGAMENTO      = null
        

    },
    ajustarCamposTabelaVendas(dados) {
      
        this.venda.DT_PEDIDO = Tools.formatarDataParaInput(dados.DT_PEDIDO)
        this.venda.DT_INICIAR_PAGAMENTO = Tools.formatarDataParaInput(dados.DT_INICIAR_PAGAMENTO)
        this.venda.DT_SAIDA = Tools.formatarDataParaInput(dados.DT_SAIDA)
        if (this.venda.DT_PAG) {
          this.venda.DT_PAG = Tools.formatarDataParaInput(this.venda.DT_PAG)
        }
    },
    async iniciarFormEditar(id) {
      try {
        const response = await this.$http.get(`/api/protected/venda/getById/${id}`)
        const vendaResponse = response?.data?.[0]

        if (!vendaResponse) {
          throw new Error('O Pedido não foi localizado!')
        }

        this.venda = vendaResponse
        this.ajustarCamposTabelaVendas(this.venda)
        this.traduzirAbate()
        

        this.vlTotalAntes = this.venda.VL_TOTAL_NFE
            
        if (['0','1','6','7'].includes(this.venda.SITUACAO)) {
          this.controles.fechada = true
        } else {
          this.controles.fechada = false
        }
      } catch (err) {
        throw new Error(err.message || err)
      }
    },
    
    
    async carregarParametros () {
      try {
        const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/parametro/getDados'))
        const dados = response.data

        return dados?.[0]

      } catch (err) {
        console.error('Erro em carregarParametros:', err)
        return null
      }
    },
    handleMouseDownAcrescentarItem(item) {
      this.isProcessoLongo = false;
      this.timerBotao = setTimeout(() => {
        this.isProcessoLongo = true;
        this.iniciarAcrescimoItem(item);
      }, 500); // 0.5 segundos para começar o incremento contínuo
    },
    handleMouseUpAcrescentarItem(item) {
      clearTimeout(this.timerBotao);
      if (this.isProcessoLongo) {
        clearInterval(this.intervaloBotao);
      } else {
        this.acrescentarItemSimples(item);
      }
      this.isProcessoLongo = false;
    },
    handleMouseLeaveAcrescentarItem() {
      clearTimeout(this.timerBotao);
      clearInterval(this.intervaloBotao);
      this.isProcessoLongo = false;
    },
    iniciarAcrescimoItem(item) {
      this.intervaloBotao = setInterval(() => {
        if (item.PECAS_PEDIDO + 10 <= item.PECAS) {
          item.PECAS_PEDIDO += 10;
        } else {
          item.PECAS_PEDIDO = item.PECAS;
          clearInterval(this.intervaloBotao);
        }
      }, 100); // Incrementa 10 a cada 0.1 segundo (100ms)
    },
    acrescentarItemSimples(item) {
      if (item.PECAS_PEDIDO + 1 <= item.PECAS) {
        item.PECAS_PEDIDO += 1;
      } else {
        item.PECAS_PEDIDO = item.PECAS;
      }
    },
    handleMouseDownDecrementarItem(item) {
      this.isProcessoLongo = false;
      this.timerBotao = setTimeout(() => {
        this.isProcessoLongo = true;
        this.iniciarDecrementoItem(item);
      }, 500); // 0.5 segundos para começar o decremento contínuo
    },
    handleMouseUpDecrementarItem(item) {
      clearTimeout(this.timerBotao);
      if (this.isProcessoLongo) {
        clearInterval(this.intervaloBotao);
      } else {
        this.decrementoItemSimples(item);
      }
      this.isProcessoLongo = false;
    },
    handleMouseLeaveDecrementarItem() {
      clearTimeout(this.timerBotao);
      clearInterval(this.intervaloBotao);
      this.isProcessoLongo = false;
    },
    iniciarDecrementoItem(item) {
      this.intervaloBotao = setInterval(() => {
        if (item.PECAS_PEDIDO - 10 >= 0) {
          item.PECAS_PEDIDO -= 10;
        } else {
          item.PECAS_PEDIDO = 0;
          clearInterval(this.intervaloBotao);
        }
      }, 100); // Decrementa 10 a cada 0.1 segundo (100ms)
    },
    decrementoItemSimples(item) {
      if (item.PECAS_PEDIDO - 1 >= 0) {
        item.PECAS_PEDIDO -= 1;
      } else {
        item.PECAS_PEDIDO = 0;
      }
    },
    handleMouseDownAcrescentarItemAlteracao() {
      this.isProcessoLongo = false;
      this.timerBotao = setTimeout(() => {
        this.isProcessoLongo = true;
        this.iniciarAcrescimoItemAlteracao();
      }, 500); // 0.5 segundos para começar o incremento contínuo
    },
    handleMouseUpAcrescentarItemAlteracao() {
      clearTimeout(this.timerBotao);
      if (this.isProcessoLongo) {
        clearInterval(this.intervaloBotao);
      } else {
        this.acrescentarItemSimplesAlteracao();
      }
      this.isProcessoLongo = false;
    },
    handleMouseLeaveAcrescentarItemAlteracao() {
      clearTimeout(this.timerBotao);
      clearInterval(this.intervaloBotao);
      this.isProcessoLongo = false;
    },
    iniciarAcrescimoItemAlteracao(item) {
      this.intervaloBotao = setInterval(() => {
        const pecasAtual = Number(this.item.PECAS_PEDIDO) || 0;
        if (pecasAtual + 10 <= this.originalPecasPedido) {
          this.item.PECAS_PEDIDO = pecasAtual + 10
        } else {
          this.item.PECAS_PEDIDO = this.originalPecasPedido
          clearInterval(this.intervaloBotao)
        }
      }, 100); // Incrementa 10 a cada 0.1 segundo (100ms)
    },
    acrescentarItemSimplesAlteracao() {
      const pecasAtual = Number(this.item.PECAS_PEDIDO) || 0;
      if (pecasAtual + 1 <= this.originalPecasPedido) {
        this.item.PECAS_PEDIDO = pecasAtual + 1
      } else {
        this.item.PECAS_PEDIDO = this.originalPecasPedido
      }
    },
    handleMouseDownDecrementarItemAlteracao() {
      this.isProcessoLongo = false;
      this.timerBotao = setTimeout(() => {
        this.isProcessoLongo = true;
        this.iniciarDecrementoItemAlteracao();
      }, 500); // 0.5 segundos para começar o decremento contínuo
    },
    handleMouseUpDecrementarItemAlteracao() {
      clearTimeout(this.timerBotao);
      if (this.isProcessoLongo) {
        clearInterval(this.intervaloBotao);
      } else {
        this.decrementoItemSimplesAlteracao();
      }
      this.isProcessoLongo = false;
    },
    handleMouseLeaveDecrementarItemAlteracao() {
      clearTimeout(this.timerBotao);
      clearInterval(this.intervaloBotao);
      this.isProcessoLongo = false;
    },
    iniciarDecrementoItemAlteracao() {
      this.intervaloBotao = setInterval(() => {
        const pecasAtual = Number(this.item.PECAS_PEDIDO) || 0;
        if (pecasAtual - 10 >= 0) {
          this.item.PECAS_PEDIDO = pecasAtual - 10;
        } else {
          this.item.PECAS_PEDIDO = 0;
          clearInterval(this.intervaloBotao);
        }
      }, 100); // Decrementa 10 a cada 0.1 segundo (100ms)
    },
    decrementoItemSimplesAlteracao() {
      const pecasAtual = Number(this.item.PECAS_PEDIDO) || 0;
      if (pecasAtual - 1 >= 0) {
        this.item.PECAS_PEDIDO = pecasAtual - 1;
      } else {
        this.item.PECAS_PEDIDO = 0;
      }
    },
    removerPecas(item) {
      if (item.PECAS_PEDIDO > 0 ) {
        item.PECAS_PEDIDO--
      }
    },
    
    
    forceValidation(linha) {
      const maxPecas = parseInt(linha.item.PECAS, 10);
      let currentPecas = parseInt(linha.item.PECAS_PEDIDO, 10);

      if (currentPecas > maxPecas) {
        linha.item.PECAS_PEDIDO = maxPecas;
      }
    },
    colorirLimiteCredito(valor) {
      if (valor === 0) return 'primary'
      else if (valor > 0) return 'success'
      else return 'danger'
    },
    traduzirSituacao(value) {
      let $variant
      if ( value == '0'  ) {
        $variant = 'CANCELADO'
      } else if ( value == '1'  ) {
        $variant = 'FATURADO'
      } else if ( value == '2'  ) {
        $variant = 'EM CADASTRO'
      } else if ( value == '3'  ) {
        $variant = 'AGUARDANDO ORDEM'
      } else if ( value == '4'  ) {
        $variant = 'ORDEM EXPEDIÇÃO'
      } else if ( value == '5'  ) {
        $variant = 'EMBARCANDO'
      } else if ( value == '6'  ) {
        $variant = 'EMBARCADO'
      }
      return $variant
    },
    async atualizarCliente() {
      try {
        const response = await this.$http.get(`/api/protected/clientes/getDetalhesParaVenda/${this.venda.COD_CLI}`)
        const cliente = response.data[0]

        if (!cliente) {
          throw new Error('Cliente não encontrado')
        }

        this.cliente = cliente
        return true

      } catch (error) {
        console.error('Erro ao atualizar cliente:', error)
        return false
      }
    },
    async getItens() {
      try {
        const response = await this.$http.get('/api/protected/retiradaservico/item/getListagemByPedido/'+this.venda.SEQUENCIA)
        const dados = response.data
        return dados

      } catch (err) {
        console.error('Erro em getItens:', err)
        return null
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown)
    clearTimeout(this.timerBotao)
    clearInterval(this.intervaloBotao)
  },
  async created () {
    try {
      this.controles.montagemTelaConcluida = false
      try {
        this.$store.commit('controle/setAguardando', true)
        let id = this.$route.params.id
        
        this.parametros =  await this.carregarParametros()
        
        if (!this.parametros) {
          throw new Error(`Os parametros do Sistema não foram carregados!!`)
        }

        if (this.parametros.OP_VENDA_PRECO_POR_TABELA === 'T' ) {
          this.precoTabelado = true
        } else {
          this.precoTabelado = false
        }

        if (this.parametros.OP_EXPEDICAO_DIRETA === '1')  {
          this.controles.expedicaoDireta = true
        } else {
          this.controles.expedicaoDireta = false
        }
        

        
        //VENDA EM ALTERACAO
        if ( id ) {
          try {
              await this.iniciarFormEditar( id )
          } catch (err) {
            console.log(err)
            throw new Error(err.message || err)
          }

          
          try {
            
            let result = await this.getItens()
            this.montarTabelaItens(result)
          } catch (err) {
            console.log(err)
            throw new Error(`Os produtos da Venda/Prefatura, não foram encontrados!!`)
          }

          this.vendaIdEditar = id
          this.controles.vendaAlteracao = true
          
          
        } 
        // NOVA VENDA
        else { 
          
          this.limparVenda()

          this.venda.OBSERVACOES = this.parametros.LINHA1ROMA + '\n' + this.parametros.LINHA2ROMA + '\n' + this.parametros.LINHA3ROMA
          this.venda.TIPO_MOVIMENTACAO_ID      = this.parametros.TIPO_MOVIMENTACAO_VENDA_INT_ID
          this.venda.SEQUENCIA                 = null
          this.venda.N_VENDA                   = null
          this.venda.DT_SAIDA                  = Tools.getDataAtual()
          this.venda.DT_PEDIDO                 = Tools.getDataAtual()
          this.venda.DT_INICIAR_PAGAMENTO      = Tools.getDataAtual()
          this.venda.SITUACAO                  = '2'
          this.venda.OP_PEDIDO                 = '2' //retirada do Servico
          this.venda.PAG2                      = '0'
          this.venda.TIPO_VEN                  = '0'
          this.venda.FORMA                     = 'VENDA'
          this.venda.USUARIO                   = window.localStorage.getItem('login')
          this.venda.USUARIO_LANCAMENTO_WEB    = window.localStorage.getItem('login')
          this.venda.USUARIO_PEDIDO            = window.localStorage.getItem('login')
          this.venda.NENTREGA                  = '0'
          this.venda.VL_TOTAL_RETORNO_BKP      = 0.00
          this.venda.VL_TOTAL_RETORNO          = 0.00
          this.venda.PESOLIQUIDO               = 0.00
          this.venda.PESOBRUTO                 = 0.00
          this.venda.VL_TOTAL_ANTES_ALTERACAO  = 0.00
          this.venda.VL_BASE_CALC_ICMS         = 0.00
          this.venda.VL_TOTAL_ICMS             = 0.00
          this.venda.VL_BASE_CALC_ST_ICMS      = 0.00
          this.venda.VL_TOTAL_ST_ICMS          = 0.00
          this.venda.VL_TOTAL_IPI              = 0.00
          this.venda.VL_TOTAL_PIS              = 0.00
          this.venda.VL_TOTAL_COFINS           = 0.00
          this.venda.VL_TOTAL_DESCONTO         = 0.00
          this.venda.VL_TOTAL_SEGURO           = 0.00
          this.venda.VL_TOTAL_OUTRAS_DESP      = 0.00
          this.venda.VL_TOTAL_FRETE            = 0.00
          this.venda.NR_PESO_BRUTO             = 0.00
          this.venda.VL_TOTAL_PRODUTOS         = 0.00
          this.venda.NR_PESO_LIQUIDO           = 0.00
          this.venda.VL_TOTAL_NFE              = 0.00

          this.vendaIdEditar = null
          this.controles.vendaAlteracao = false
          this.controles.fechada = false
          
          
          
          // ⏳ Delay para garantir que o DOM e refs estejam prontos
          setTimeout(() => {
            try {
              document.addEventListener("keydown", this.handleKeydown)

              const campoCliente = this.$refs.edCOD_CLI?.$refs?.auto?.$refs?.autocomplete
              if (campoCliente && typeof campoCliente.focus === 'function') {
                campoCliente.focus()
              } else {
                console.warn('Campo cliente-pesquisa não encontrado para foco')
              }
            } catch (err) {
              console.error('Erro ao tentar focar o campo cliente-pesquisa:', err)
            }
          }, 200)
          
      

        }
      } catch (err) {
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
        
        return
      }
    } finally {
      this.controles.montagemTelaConcluida = true
      this.$store.commit('controle/setAguardando', false)

      console.log('fim do created')
      console.log('montagemTelaConcluida:', this.controles.montagemTelaConcluida)
    }
  },
  mounted (){
    let id = this.$route.params.id
    if ( id == null  ) {
      //this.$refs.ob_edDocumento.focus()
      this.$refs.edCOD_CLI.$refs.auto.$refs.autocomplete.focus()
    }

    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
      console.log('setTimeout do mounted')
      console.log('montagemTelaConcluida:', this.controles.montagemTelaConcluida)
    }, 200)
  },
  watch: {
    'venda.COD_CLI': async function (val, oldVal) {
      if (!val) {
        this.cliente.CODIGO = null
        this.cliente.NOME = null
        this.cliente.RAZAOSOCIAL = null
        this.cliente.ID_UF = null
        this.cliente.FIZ_JUR = null
        this.cliente.ISENTO_ICMS = null
        this.cliente.COD_VEND = null
        this.cliente.NOTAS_EM_ABERT0 = 0
        this.cliente.PRAZO = null
        this.cliente.TIPO_CLI = null
        this.cliente.GRUPO_ARECEBER_ID = null
        return
      }
     
      const sucesso = await this.atualizarCliente()

      if (!sucesso) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel atualizar os dados do Cliente' )
      }
      
    },
    'venda.ABATE_ID': function(val) {
      if (val) {
        this.traduzirAbate()
      } else {
        this.textoAbate = ''
      }
    }


    
  }
}
</script>
<style scoped>
.autonumeric_required{
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 0px;
  /* padding: 0.35rem 0.75rem; */
  padding: 0.35rem 0.75rem;
  border-color: #f86c6b;
}
/* Simula o verde de validação */
.autonumeric_is-valid {
  border-color: #28a745 !important;
  background-color: #fff;
}

/* PREMIUM UI STYLES */
.page-shell {
  background-color: #f4f7f9;
  min-height: 100vh;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.rounded-lg {
  border-radius: 1rem !important;
}

.transition-hover {
  transition: all 0.3s ease;
}

.transition-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 15px rgba(0,0,0,0.1) !important;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%) !important;
}

.bg-gradient-success {
  background: linear-gradient(135deg, #28a745 0%, #218838 100%) !important;
}

.bg-gradient-danger {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
}

.bg-gradient-warning {
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%) !important;
}

.btn-glass {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white !important;
  font-weight: 600;
  padding: 0.5rem 1.25rem;
  border-radius: 50px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

.btn-glass:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.btn-glass-success:hover { background: rgba(40, 167, 69, 0.8); }
.btn-glass-info:hover { background: rgba(23, 162, 184, 0.8); }
.btn-glass-primary:hover { background: rgba(0, 123, 255, 0.8); }
.btn-glass-danger:hover { background: rgba(220, 53, 69, 0.8); }

.modal-header-premium {
  border-bottom: 0;
  position: relative;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.bg-warning-soft {
  background-color: rgba(255, 193, 7, 0.15) !important;
}

/* Custom Pill Group for Numeric Inputs */
.cec-pill-group {
  display: flex;
  align-items: stretch;
  border-radius: 50px;
  overflow: hidden;
  background: #fff;
}

.cec-pill-left {
  border-top-left-radius: 50px !important;
  border-bottom-left-radius: 50px !important;
  border-right: 0 !important;
}

.cec-pill-right {
  border-top-right-radius: 50px !important;
  border-bottom-right-radius: 50px !important;
  border-left: 0 !important;
}

.cec-pill-append .btn {
  margin: 0 !important;
  height: 100%;
  display: flex;
  align-items: center;
}

.opacity-75 {
  opacity: 0.75;
}

.table-premium thead th {
  background-color: #f8f9fa;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  font-weight: 700;
  border-top: 0;
  border-bottom: 2px solid #e9ecef;
  color: #495057;
  padding: 1rem 0.75rem;
}

.table-premium tbody td {
  padding: 1rem 0.75rem;
  vertical-align: middle;
  border-bottom: 1px solid #f1f3f5;
}

.table-premium tbody tr:hover {
  background-color: rgba(74, 144, 226, 0.03);
}
</style>





// WEBPACK FOOTER //
// src/views/expedicao/retiradaServico/RetiradaServicoCadastro.vue